import PlayerHelper from './../helpers/PlayerHelper';
import * as constant from './../constants';
import Api from './../helpers/Api';
import Device from './../../devices/device';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import PlayerStreamingUtils from '../../utils/PlayerStreamingUtils';
import getAppConfig from '../../config/appConfig';
import RequestManager from '../../requests/RequestManager';
import SimpleGetRequestTask from '../../requests/tasks/SimpleGetRequestTask';
import {
  onStreamNotFound,
  onConnectionTimeout,
  onNetworkDisconnected,
  onAuthenticationFailed,
  onUnknownError,
  onResolvePlayingError,
  onResolveGetmediaError
} from './../../utils/playerConstants';

import CheckUrlTask from 'src/requests/tasks/application/CheckUrlTask.js';


import * as playerConstant from './../../utils/playerConstants';

import Utils, { showSpinner } from './../../utils/Utils';
import AAFResolveException from './AAFResolveException';
import Translator from '../../requests/apa/Translator';
// Sólo constantes de modales
import {
  AAF_MODAL_ERROR,
  MODAL_PIN,
  MODAL_REINTENTO,
  MODAL_END_PLAYER,
  AAF_MODAL_PLAY_OPTIONS,
  AAF_MODAL_INICIAL_ACTIVA_HBO_MAX,
  showModal
} from '../../actions/modal';
import PlayerAudioSubtitleHelper from './../helpers/PlayerAudioSubtitleHelper';
import settings from '../../devices/all/settings';
import AAF from './../../AAF/AAF';
import asyncPinObserver from './../../AAF/Pin/AsyncPinObserver';
import { UpdateMiniObserver } from '../../components/PersistentMiniEpg/MiniObserver';
import MultipleLangLive from '../../AAF/LanguageLive/MultipleLangLive';
import stopTrackingObserver from '../helpers/StopTrackingObserver';
import { MODAL_PIN_CODE_RATING_TYPE } from '../../components/Modal/ModalPinCode';
import TvChannelUtil from '../../utils/TvChannelUtil';
import store from '../../store'

import { ThirdPartyEpgHelper } from '../../AAFPlayer/helpers/ThirdPartyEpgHelper';
import NewRelic from 'src/utils/trackers/NewRelic';
import { HBO_SUBSCRIPTION, PENDING, UNLINKED, HBO_ACTIVATION_MODAL_DELAY_MS } from '../../components/RibbonNew/constants';
import logger from 'src/utils/logger/logger';

class AAFPlayerMain {
  // Instancia de player, por device
  playerInstance = null;
  playerInstancePip = null;

  // Util diversas tareas
  playerHelper = null;

  // Array de audio tracks, si aplica
  audioTracks = [];
  // Indica si ya se cargaron los audioTracks
  audioTracksLoaded = false;

  // EL INPUT Las opciones de playing, que vienen desde el dispatch/call
  tryingToPlayOptions = null;
  playerOptions = null;
  playerOptionsPip = null;

  // EL OUTPUT Los parametros que se enviaron al player
  devicePlayerParams = {};
  devicePlayerParamsPip = {};

  // Tiempo para lanzar el finplayer
  creditsTime = 0;
  isEndPlayer = false;

  // Is PIP
  isPip = false;

  callbacks = {};
  bindedevents = {};
  wrapperContainer = null;

  /**
   * Estado actual del player playing o stopping
   */
  currentPlayingState = constant.AAFPLAYER_STOP;
  currentPlayingStatePip = constant.AAFPLAYER_STOP;

  /**
   * Tipo de contenido que se esta playeando en estos momentos(uno de estos: vod, tv, catchup, timeshift, audio, radio...o null/nada)
   */
  currentContentType = null;
  currentContentTypePip = null;

  timeShift = null;
  audioTracks = [];
  audioTracksLoaded = false;

  // Current pgm
  pgm = null;
  pgmpip = null;

  /*
   * Previous Channel
   */
  currentChannel = null;

  lastStreamTypeUsed = null;

  asyncPinEventsCounter = 0;
  asyncPinPreviousChannel = null;

  // Canales desbloqueados vía PIN desde MatchDetailVideoPanel en esta sesión
  _matchDetailUnlockedChannels = new Set();

  /**
   * Await getmedia
   */
  awaitGetMediaInterval = 0.5; // seconds
  awaitGetMediaIntervalID = null;
  awaitGetMediaIntervalMaxAttemps = 4; // Seconds

  /**
   *
   */
  constructor() {
    this.playerStreamingUtils = new PlayerStreamingUtils();
    this.platform = Device.getDevice().getPlatform();
    this.forceStopPlayer = false;
    /**
     * Para el caso de las STBs android, hay subplatform: stbkaon, stbhuawei, stbconship
     */
    this.subplatform = null;
    if (Utils.isFunction(Device.getDevice().getSubplatform)) {
      let subplatform = Device.getDevice().getSubplatform();
      if (subplatform != undefined) {
        this.subplatform = subplatform;
      }
    }

    this.playerInstance = Device.getDevice().getPlayer();
    // TODO ajustar boot de la app a que realmente regrese dos instancias de players
    this.playerInstancePip = Device.getDevice().getPlayer();
    this.__checkBookmark = this.__checkBookmark.bind(this);
    this.__resolveLiveAsyncPin = this.__resolveLiveAsyncPin.bind(this);
    this.__handleAsyncPinObserver = this.__handleAsyncPinObserver.bind(this);
    this.__prepareAsyncObserver = this.__prepareAsyncObserver.bind(this);
    this.__handlePGM = this.__handlePGM.bind(this);
    this.__handleNotPGM = this.__handleNotPGM.bind(this);
    this.__fireTPAAppResult = this.__fireTPAAppResult.bind(this);

    this.__awaitGetMedia = this.__awaitGetMedia.bind(this);
    this.__handleAwaitGetMediaObserver = this.__handleAwaitGetMediaObserver.bind(this);

    this.setForceStopPlayer = this.setForceStopPlayer.bind(this);

    this.comeFromNonSuscChannel = false;
    this.asyncPinEventsCounter = 0;
    this.asyncPinPreviousChannel = null;

    asyncPinObserver.subscribe(this.__handleAsyncPinObserver);
    this.deviceId = Utils.getDeviceID();

    this.mundial2026InputOptions = null;
  }

  /**
   * get RESOLVED params
   *
   * @param {*} isPip
   *
   * Regresa una copia de los params, por si el user las manipula
   */
  getDevicePlayerParams(isPip) {
    return isPip
      ? Object.assign({}, this.devicePlayerParamsPip)
      : Object.assign({}, this.devicePlayerParams);
  }

  /**
   * get trying to play options
   *
   * @param {*} isPip
   */
  getTryingToPlayOptions() {
    return this.tryingToPlayOptions;
  }
  /**
   * get trying to play options from full options, only imporotant options to know if the trying is diferent
   *
   * @param object fullOptions
   */
  getTryingToPlayOptionsFromFullOptions(fullOptions) {
    return {
      playerstate: fullOptions.playerstate,
      source: fullOptions.source,
      size: fullOptions.size,
      ispip: fullOptions.ispip,
      islive: fullOptions.islive,
      ispreview: fullOptions.ispreview
    }
  }

  /**
   * get current playing state (PLAYING|STOPPING)
   *
   * @param {*} isPip
   */
  getCurrentPlayingState(isPip) {
    return isPip ? this.currentPlayingStatePip : this.currentPlayingState;
  }

  /**
   * get current content that is playing vod, live, catchup, timeshift etc
   *
   * @param {*} isPip
   */
  getCurrentContentType(isPip) {
    if (isPip) return this.currentContentTypePip;
    else return this.currentContentType;
  }

  /**
   * get params AAFPlayer was (last) called with
   *
   * @param {*} ispip
   *
   * Regresa una copia de las options, por si el user las manipula
   */
  getCurrentPlayerOptions(isPip) {
    if (isPip) {
      return Object.assign({}, this.playerOptionsPip);
    } else {
      return Object.assign({}, this.playerOptions);
    }
  }

  setTryingToPlayOptions(options) {
    this.tryingToPlayOptions = options
  }

  setCurrentPlayingState(nextPlayingState, isPip) {
    if (isPip) this.currentPlayingStatePip = nextPlayingState;
    else this.currentPlayingState = nextPlayingState;
  }

  setCurrentContentType(nextContentType, isPip) {
    if (this.isPip) this.currentContentTypePip = nextContentType;
    else this.currentContentType = nextContentType;
  }

  setDevicePlayerParams(devicePlayerParams, isPip) {
    let _devicePlayerParams = {};
    Object.assign(_devicePlayerParams, devicePlayerParams);
    if (isPip) this.devicePlayerParamsPip = _devicePlayerParams;
    else this.devicePlayerParams = _devicePlayerParams;
  }

  setCurrentPlayerOptions(playerOptions, isPip) {
    let _playerOptions = {};
    Object.assign(_playerOptions, playerOptions);
    if (isPip) this.playerOptionsPip = _playerOptions;
    else this.playerOptions = _playerOptions;
  }

  getContentType(nextOptions) {
    return PlayerHelper.getContentType(nextOptions);
  }

  isResizeToFull(nextState) {
    let willResizeToFull = false;
    // current state
    const modePip = this.livePlayingAsPip();
    // Si esta actualmente en pip es live, por defecto
    if (modePip) {
      const playerOptions = this.getCurrentPlayerOptions(false);
      const nextContentType = PlayerHelper.getContentType(nextState);
      const sameSource = PlayerHelper.sameMediaContent(
        playerOptions,
        nextState,
        nextContentType
      );

      // Puede ser sólo resize, o puede ser de pip le dieron clic a otro canal
      let TVtoTV = false;
      if (!sameSource) {
        TVtoTV = nextContentType === constant.AAF_CONTENT_IS_TV && playerOptions.streamContentType === constant.AAF_CONTENT_IS_TV;
      }

      if ((sameSource || TVtoTV)
        && nextState.size &&
        nextState.size.width > 1279) {
        willResizeToFull = true;
      }
    }

    return willResizeToFull;
  }

  __getThirdPartyApp(nextOptions, nextContentType = null) {
    return ThirdPartyEpgHelper.getThirdPartyApp(nextOptions, nextContentType);
  }

  __fireTPAApp(TPA, nextOptions) {
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    logger.debug('[TPA] AAFPlayerMain::__fireTPAApp enter...le lanzará TPA: ', TPA);
    const isPip = false; // No hay soporte true pip en ningún device
    let currentPlayingState = this.getCurrentPlayingState(isPip);
    logger.debug('[TPA] AAFPlayerMain::__fireTPAApp estado actual del player: ', currentPlayingState);

    logger.debug('[TPA] AAFPlayerMain::__fireTPAApp se manda STOP');
    this.stopPlayer(isPip, false);

    // Se limpia el loading
    if (Utils.isFunction(this.callbacks.clearLoading)) {
      logger.debug('[TPA] AAFPlayerMain::__fireTPAApp se lanza clearLoading');
      this.callbacks.clearLoading();
    }
    // Notificar que se lanzará una nueva app
    if(Utils.isFunction(this.callbacks.onFireTPA)) {
      logger.debug('[TPA] AAFPlayerMain::__fireTPAApp se lanza notificación onFireTPA');
      this.callbacks.onFireTPA(TPA, nextOptions);
    }

    ThirdPartyEpgHelper.fireTPA(TPA, nextOptions, this.__fireTPAAppResult);

    return true;
  }

  __fireTPAAppResult(TPA, playerOptions, result) {
    if(!Utils.isBoolean(result)) {
      if(Utils.isString(result)) {
        result === 'true' ? true : false;
      }
    }

    if(!result) {
      if(Utils.isFunction(this.callbacks.onResultFireTPA)) {
        this.callbacks.onResultFireTPA(TPA, playerOptions, result);
      }
    }
  }

  __getVideoParamsMundial2026(options) {

    const config = getAppConfig();

    return {
        src:
          this.platform !== 'workstation'
            ? options.playbackData.videoUrl
            : 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4?t=' +
            Math.random(),
        //src: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4?t=" + Math.random(),
        controls: false,
        muted: false,
        drmInfo: {
          server_url: options.playbackData.serverUrl,
          challenge: options.playbackData.challenge,
          content_id: null,
          device_id: config.device_id,
          certificate_url: options.playbackData.certificate_url,
          resultCert: config.resultCert
        },
        autoPlay: true,
        isLive: true,
        groupId: options.source.videoid,
        streamType: options.streamType,
        resume: 0,
        backgroundImage: null,
        isTrailer: false,
        creditsTime: null,
        shortLanguageOptions: null,
        extendedCommonLangOptions: null, //  pgm options langs (for choose lang by user)
        multipleLangOptions: null, // pgm media.languages options, to set audio/subtitle tracks
        provider: null,
        // TODO checar con android si realmente necesitan pgm
        playerMedia: options.playbackData,
        isPip: false,
        parentWrapper: this.wrapperContainer,
        streamContentType: constant.AAF_CONTENT_IS_TV,
        isTPA: false,
        isFallback: false,
        mundial2026: true
      };
  }

  __sendToPlayMundial2026(nextOptions) {
    this.playerInstance = Device.getDevice().getPlayer();// está línea permite hacer el cambio a bitmovin si es necesario
    const playerParams = this.__getVideoParamsMundial2026({...nextOptions});
    playerParams.events = this.bindedevents;
    playerParams.streamContentType = constant.AAF_CONTENT_IS_TV;
    this.playerInstance.createMedia(playerParams);
    this.playerInstance.loadMedia(playerParams);
    this.setCurrentPlayingState(constant.AAFPLAYER_PLAY, false);
    //asyncPinObserver.fire('player-load-media');

    if (this.callbacks.onResolveParams) {
      playerParams.audiosubtitleinfo = null;
      this.callbacks.onResolveParams({...playerParams}, {...nextOptions}, false);
    }
  }

  /**
   *
   * Inicia siguiente playing (o resize o replace media source)
   * NOTA: ===> Llega aquí porque se quiere playear => nextState igual a AAFPLAYER_PLAY
   * @param {*} nextOptions siguientes opciones de playing, desde el dispatch
   */
  __setNextPlayerState(nextOptions) {

    if(nextOptions.mundial2026) {
      this.mundial2026InputOptions = {...nextOptions};
      this.__sendToPlayMundial2026(nextOptions);

      return;
    }

    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    // Recuperar el siguiente content type, si resuelve null entonces quiza sólo quieran hacer resize
    let nextContentType = PlayerHelper.getContentType(nextOptions);

    // NOTA: se pasa check de si es TPA a AAFPlayer

    let playerOptions = playerOptions = this.getCurrentPlayerOptions(false);
    let sameSource = PlayerHelper.sameMediaContent(
      playerOptions,
      nextOptions,
      nextContentType
    );

    try{
      if(sameSource) {
        return;
      }
      else {
        this.setTryingToPlayOptions(this.getTryingToPlayOptionsFromFullOptions(nextOptions))
      }
    }
    catch(err){
      logger.debug('__setNextPlayerState JSON.stringify error');
    }
    if (window.performance) {
      window.INICIONEXTPLAYERSTATE = window.performance.now();
      logger.debug(
        '[TIMEMARK] AAFPlayerMain entrando en  __setNextPlayerState ' +
        window.performance.now()
      );
    }


    // Verificar por el estado actual del player
    let currentPlayingState = this.getCurrentPlayingState(nextOptions.ispip);
    const isChangeEpisodeOrLang = nextOptions.ischangeepisode || nextOptions.ischangelang;
    this.asyncPinEventsCounter = 0;
    switch (currentPlayingState) {
      case constant.AAFPLAYER_PLAY:
        // Si se quiere seguir en play pero no envian data de playing,
        // entonces es probable que se trate de resize
        if (nextContentType === null) {
          if (
            nextOptions.size &&
            nextOptions.size.width &&
            nextOptions.size.height
          //todo accept left and top 0
          ) {
            this.__resizePlayer(nextOptions.size, nextOptions.ispip);
          }
          // Resize y return
          return;
        }

        // Si es del mismo contentType el sig contenido a playear, o resize o replace
        let currentContentType = this.getCurrentContentType(nextOptions.ispip);
        if (currentContentType === nextContentType) {

          // Casi seguro que es resize
          if (sameSource) {
            if (
              nextOptions.timeshiftData &&
              Utils.isNotNullOrNotUndefined(
                nextOptions.timeshiftData.timeshiftDelay
              ) &&
              !Utils.isNotNullOrNotUndefined(playerOptions.timeshiftData)
            ) {
              this.stopPlayer(nextOptions.ispip, isChangeEpisodeOrLang);
              this.__startPlayer(nextOptions);
            } else if (
              nextOptions.size &&
              nextOptions.size.width &&
              nextOptions.size.height
            ) {
              this.__resizePlayer(nextOptions.size, nextOptions.ispip);
            } // No hay else, si esta en playing y viene el mismo source nada que hacer
          }
          // Replace, en este punto hay sig content type y hay media source, se hace replace
          else {
            logger.debug(
              '>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>',
              this.platform
            );
            // switch (this.platform) {
            //     case 'android':
            //         nextOptions.hasBeenStopped = true;
            //         this.__replacePlayer(nextOptions);
            //         break;
            //     default:
            //         if (!this.__fastLiveAndFull(nextOptions)) {
            //             this.stopPlayer(nextOptions.ispip, isChangeEpisodeOrLang);
            //             nextOptions.hasBeenStopped = true;
            //         }
            //         else {
            //             nextOptions.hasBeenStopped = false;
            //         }
            //         this.__startPlayer(nextOptions);
            //         break;
            // }

            if (!this.__fastLiveAndFull(nextOptions)) {
              this.__continuePlayingSameStreamType(nextOptions, isChangeEpisodeOrLang);
            } else {
              nextOptions.hasPIN = true;
              nextOptions.hasBeenStopped = false; // Esto sirve en caso de no hacer stop antes de reproducir un VOD y estando en livePip
              if (nextOptions.modalHasBeenShown && nextOptions.modalHasBeenShown === true) {
                this.stopPlayer(nextOptions.ispip, isChangeEpisodeOrLang);
              }
              this.__startPlayer(nextOptions);
            }
          }
        } else {
          // Stop contenido actual
          this.stopPlayer(nextOptions.ispip, isChangeEpisodeOrLang);
          this.__startPlayer(nextOptions);

          // ..y play nuevo contenido
        }
        break;
      case constant.AAFPLAYER_STOP:
      default:
        // Si actualmente esta en stop, iniciar ciclo de playing
        // Iniciar play ciclo completo
        this.__startPlayer(nextOptions);
        break;
    }
  }

  async __continuePlayingSameStreamType(nextOptions, isChangeEpisodeOrLang) {
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    // Verificar por TV-live
    let nextContentType = PlayerHelper.getContentType(nextOptions);

    if (nextContentType === constant.AAF_CONTENT_IS_TV) {
      // ¿Esta suscrito?
      let checkSusc = true;
      this.playerStreamingUtils.setChangePath(this.callbacks.changePath);
      let nextContentType = PlayerHelper.getContentType(nextOptions);
      let playerOptions = this.getCurrentPlayerOptions(false);
      const isFallback = PlayerHelper.isFallback(
                  playerOptions,
                  nextOptions,
                  nextContentType
                );

      if(isFallback) {
        nextOptions.isFallback = true;
      }
      if (!this.playerStreamingUtils.canPlayChannel(nextOptions.source.videoid, isFallback)) {
        checkSusc = await this.playerStreamingUtils.checkSusc(
          null, // Este param/argumento no se usa en playerStreamingUtils, ¿por qué se pide?
          nextOptions.source.videoid // Hasta ahora no tenemos algún flujo donde no venga group id, así que este para existe si o si
        );
      }

      if (checkSusc) {
        // Sigue el flujo que ya estaba
        this.stopPlayer(nextOptions.ispip, isChangeEpisodeOrLang);
        nextOptions.hasBeenStopped = true;
        this.__startPlayer(nextOptions);
      } else {

        if (this.callbacks.clearLoading && Utils.isFunction(this.callbacks.clearLoading)) {
          this.callbacks.clearLoading();
        }
        //reset lastChannel para update correcto en miniepg
        const isCurrentPlayingState = this.getCurrentPlayingState(nextOptions.ispip) === constant.AAFPLAYER_PLAY
        const currentPlayingOptions = this.getCurrentPlayerOptions(nextOptions.ispip);
        if(nextOptions.islive && isCurrentPlayingState && currentPlayingOptions && currentPlayingOptions.source && currentPlayingOptions.source.videoid){
          const groupIdIsPlaying = currentPlayingOptions.source.videoid;
          TvChannelUtil.setLastChannel(groupIdIsPlaying);
          UpdateMiniObserver.fire(null);
        }
        // Si no está suscrito nada que hacer, se muestra la modal y ya,
        // PERO YA NO DEJA DE REPRODUCIR EN BACKGROUND, QUE ES LO MÁS IMPORTANTE
        return;
      }
    }
    // Sigue el flujo que ya estaba
    else {
      this.stopPlayer(nextOptions.ispip, isChangeEpisodeOrLang);
      nextOptions.hasBeenStopped = true;
      this.__startPlayer(nextOptions);
    }
  }

  /*
   */
  __fastLiveAndFull(nextOptions) {
    let hasPIN = this.isPinBlocked(nextOptions.source.videoid);
    return !nextOptions.ispip && nextOptions.islive && hasPIN;
  }

  /**
   * @param {*} size { top: number, left:number, width: number, height: number }
   * Aunque no exista el pip en estos momentos, el resize method sigue viviendo
   */
  __resizePlayer(size, ispip) {
    this.log('setPlayerSize', size);
    let nextOpt = null;
    if (this.isPip) {
      nextOpt = this.getCurrentPlayerOptions(true);
      this.setPlayerSize(true, size.top, size.left, size.width, size.height);
    } else {
      nextOpt = this.getCurrentPlayerOptions(false);
      nextOpt.size = size;
      this.setCurrentPlayerOptions(nextOpt, false);
      this.setPlayerSize(false, size.top, size.left, size.width, size.height);
    }
    if (
      this.callbacks.onResolveResizePlayer &&
      Utils.isFunction(this.callbacks.onResolveResizePlayer)
    ) {
      this.callbacks.onResolveResizePlayer(nextOpt);
    }
  }

  setPlayerSize(ispip, top, left, width, height) {
    if (this.isPip) {
      this.playerInstancePip.setPlayerSize(top, left, width, height);
    } else {
      this.playerInstance.setPlayerSize(top, left, width, height);
    }
  }

  /**
   * A partir de los params resueltos del player, recupera el audio y subtitle
   * track si es que hay alguno que lanzar al inicio del playing
   *
   * @param {*} playerParams
   */
  __getMediaAudioSubtitle(playerParams) {
    let langOptionId = PlayerAudioSubtitleHelper.getLanguageOptionId(playerParams);
    let audioSubtitle = PlayerAudioSubtitleHelper.resolveAudioSubtitleFromStart(playerParams);
    audioSubtitle.optionId = langOptionId;

    return audioSubtitle;
  }

  /**
   * Filtro que evita llamadas de más en contenido VOD
   */
  async __tryToPlay(nextOptions, replace) {
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);
    await this.__resolvePlayerParams(nextOptions, replace);
  }


  /**
   * Intenta playing desde cero
   */
  async __startPlayer(nextOptions) {
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    if (window.performance)
      logger.debug(
        '[TIMEMARK] AAFPlayerMain entrando en  __startPlayer ' + window.performance.now()
      );
    if (this.imageBackGround && nextOptions.resume) {
      Utils.setBackgroundImageWithoutDelay(this.imageBackGround);
    }
    await this.__tryToPlay(nextOptions, false);
  }

  async __continueStartPlayer(nextOptions, defaultStreamType = null) {

    if (window.performance)
      logger.debug(
        '[TIMEMARK] AAFPlayerMain entrando en  __continueStartPlayer ' +
        window.performance.now()
      );

    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    //logger.debug('[AAF_FWK2] enter __continueStartPlayer !!!!' );
    // Webinitiator? url directa al player
    let provider = null;
    let providerCode = null;
    let pgmToUse = null;
    if (nextOptions.ispip) {
      pgmToUse = this.pgmpip;
    } else {
      pgmToUse = this.pgm;
    }
    provider = PlayerHelper.getProviderFromPgm(pgmToUse);
    providerCode = PlayerHelper.getProviderCodeFromPgm(pgmToUse);
    let streamType = null;
    if (pgmToUse.media && pgmToUse.media.streamType) {
      streamType = pgmToUse.media.streamType;
    } else if (defaultStreamType) {
      streamType = defaultStreamType;
    }

    //pgmToUse = await this.playerStreamingUtils.replaceSourceMedia(pgmToUse, streamType, provider, providerCode, nextOptions.islive);
    /**
     * Para performance en el cambio de canal
     * y solo para live en stbkaon y stbhuawei
     * que no requieren de mapear PGM en live.
     * Esto ahorra entre 1 y 2 segs (quita awaits)
     */
    if (nextOptions.islive) {
      switch (this.subplatform) {
        /**
         * ****************** ****************** ******************
         * IMPORTANTE: si se requiere transformar PGM en live,
         * entonces este switch debe desaparecer y en su lugar
         * se queda el default de este mismo switch
         * ****************** ****************** ******************
         */
        case 'stbkaon':
        case 'stbhuawei':
          // No se hace nada para kaon y huawei
          break;
        default:
          pgmToUse = await this.playerStreamingUtils.replaceSourceMedia(
            pgmToUse,
            streamType,
            provider,
            providerCode,
            nextOptions.islive,
            nextOptions.streamContentType
          );
          break;
      }
    }
    // VOD y demás pasa por el replace
    else {
      pgmToUse = await this.playerStreamingUtils.replaceSourceMedia(
        pgmToUse,
        streamType,
        provider,
        providerCode,
        nextOptions.islive,
        nextOptions.streamContentType
      );
    }

    if (nextOptions.ispip) {
      let pgmpip = {};
      Object.assign(pgmpip, pgmToUse);
      this.pgmpip = pgmpip;
      this.pgmpip.media.streamType = streamType;
    } else {
      let pgmfull = {};
      Object.assign(pgmfull, pgmToUse);
      this.pgm = pgmfull;
      this.pgm.media.streamType = streamType;
    }

    let playerParamsTimeshist = this.__getVideoParams(nextOptions, pgmToUse);
    let playerParams = playerParamsTimeshist;

    // Actualizar data interno
    let nextContentType = PlayerHelper.getContentType(nextOptions);
    playerParams.currentContentType = nextContentType;

    let audioSubtitleOptions = this.__getMediaAudioSubtitle(playerParams);
    playerParamsTimeshist.audiosubtitleinfo = audioSubtitleOptions;

    // Verificar si es timeshift, para mandarle el flag al playerdevice
    if (nextOptions.starttime && !nextOptions.endtime) {
      playerParamsTimeshist.timeshift = nextOptions.starttime;
    }
    this.__sendToPlay(playerParamsTimeshist);

    let inputParamsToReturn = null;
    if (nextOptions.ispip) {
      let playerParamsClonePip = {};
      Object.assign(playerParamsClonePip, playerParams);
      this.setDevicePlayerParams(playerParamsClonePip, true);
      // Actualizar estado interno, hasta el final, después de que realmente no haya error
      this.setCurrentPlayerOptions(nextOptions, true);
      this.setCurrentPlayingState(constant.AAFPLAYER_PLAY, true);
      this.setCurrentContentType(nextContentType, true);

      // get clone
      inputParamsToReturn = this.getCurrentPlayerOptions(true);
    } else {
      let playerParamsClone = {};
      Object.assign(playerParamsClone, playerParams);
      this.setDevicePlayerParams(playerParamsClone, false);
      // Actualizar estado interno, hasta el final, después de que realmente no haya error
      this.setCurrentPlayerOptions(nextOptions, false);
      this.setCurrentPlayingState(constant.AAFPLAYER_PLAY, false);
      this.setCurrentContentType(nextContentType, false);
      // get clone
      inputParamsToReturn = this.getCurrentPlayerOptions(false);
    }

    if (this.callbacks.onResolveParams) {
      // Se agregan las opciones al return para que el component controle el audio y subtitle
      this.callbacks.onResolveParams(playerParams, inputParamsToReturn, false);
    }
  }

  /**
   * NO inicia playing desde cero, intenta reemplazar el actual media source por el nuevo, para continuar en playing
   */
  async __replacePlayer(nextOptions) {
    await this.__tryToPlay(nextOptions, true);
  }

  async __continueReplacePlayer(nextOptions) {
    // Webinitiator? url directa al player?

    let provider = null;
    let providerCode = null;
    let pgmToUse = null;
    if (nextOptions.ispip) pgmToUse = this.pgmpip;
    else pgmToUse = this.pgm;
    provider = PlayerHelper.getProviderFromPgm(pgmToUse);
    providerCode = PlayerHelper.getProviderCodeFromPgm(pgmToUse);

    let streamType = null;
    if (pgmToUse.media && pgmToUse.media.streamType) {
      streamType = pgmToUse.media.streamType;
    }
    pgmToUse = await this.playerStreamingUtils.replaceSourceMedia(
      pgmToUse,
      streamType,
      provider,
      providerCode,
      nextOptions.islive
    );
    if (nextOptions.ispip) {
      let pgmpip = {};
      Object.assign(pgmpip, pgmToUse);
      this.pgmpip = pgmpip;
      this.pgmpip.media.streamType = streamType;
    } else {
      let pgmfull = {};
      Object.assign(pgmfull, pgmToUse);
      this.pgm = pgmfull;
      this.pgm.media.streamType = streamType;
    }

    let playerParams = this.__getVideoParams(nextOptions, pgmToUse);
    let newSource = {
      src: playerParams.src,
      drmInfo: playerParams.drmInfo,
      isLive: nextOptions.islive,
      streamType: playerParams.streamType,
      resume: nextOptions.resume,
      playerMedia: playerParams.playerMedia,
      isPip: nextOptions.ispip,
      groupId: nextOptions.source && nextOptions.source.videoid,
      backgroundImage: playerParams.backgroundImage
    };
    // Verificar si es timeshift, para mandarle el flag al playerdevice
    if (nextOptions.starttime && !nextOptions.endtime) {
      newSource.timeshift = nextOptions.starttime;
    }

    this.__sendReplaceToPlay(newSource);

    // Actualizar data interno
    let nextContentType = PlayerHelper.getContentType(nextOptions);
    playerParams.currentContentType = nextContentType;

    let inputParamsToReturn = null;
    if (nextOptions.ispip) {
      let playerParamsClonePip = {};
      Object.assign(playerParamsClonePip, playerParams);
      this.setDevicePlayerParams(playerParamsClonePip, true);
      // Actualizar estado interno, hasta el final, después de que realmente no haya error
      this.setCurrentPlayerOptions(nextOptions, true);
      this.setCurrentPlayingState(constant.AAFPLAYER_PLAY, true);
      this.setCurrentContentType(nextContentType, true);

      // get clone
      inputParamsToReturn = this.getCurrentPlayerOptions(true);
    } else {
      let playerParamsClone = {};
      Object.assign(playerParamsClone, playerParams);
      this.setDevicePlayerParams(playerParamsClone, false);
      // Actualizar estado interno, hasta el final, después de que realmente no haya error
      this.setCurrentPlayerOptions(nextOptions, false);
      this.setCurrentPlayingState(constant.AAFPLAYER_PLAY, false);
      this.setCurrentContentType(nextContentType, false);

      // get clone
      inputParamsToReturn = this.getCurrentPlayerOptions(false);
    }

    if (this.callbacks.onResolveParams) {
      let audioSubtitleOptions = this.__getMediaAudioSubtitle(playerParams);
      // Se agregan las opciones al return para que el component controle el audio y subtitle
      playerParams.audiosubtitleinfo = audioSubtitleOptions;
      this.callbacks.onResolveParams(playerParams, inputParamsToReturn, true);
    }

    /**
     * Abajo resize del player
     * No pasamos por this._resizePlayer definido aquí en este js
     * porque resize actualiza estado interno y en este
     * punto no necesitamos actualizarlo porque se actualiza
     * justo arriba
     */
    if (nextOptions.size && Utils.isNotNullOrNotUndefined(nextOptions.size.width)) {
      if (nextOptions.isPip) {
        this.playerInstancePip.setPlayerSize(
          nextOptions.size.top,
          nextOptions.size.left,
          nextOptions.size.width,
          nextOptions.size.height
        );
      } else {
        this.playerInstance.setPlayerSize(
          nextOptions.size.top,
          nextOptions.size.left,
          nextOptions.size.width,
          nextOptions.size.height
        );
      }
    }

    this.audioTracksLoaded = false;
    this.audioTracks = [];
  }

  /**
   * Skip a la validacion de parental y initial_playback_seconds?
   * @param {*} nextOptions
   */
  __skipPgmValidation(nextOptions) {
    return ( (!isNaN(nextOptions.resume) && !nextOptions.ispreview && !nextOptions.islive) || nextOptions.skipPin);
  }

  getPreviousChannelFastPlay() {
    return DeviceStorage.getItem('previousChannel') || null;
  }

  getPlayedChannelWithoutPin() {
    return DeviceStorage.getItem('playedChannelWithoutPin') || null;
  }

  playPreviousChannel(previousChannel, nextOptions, isSourceReplace) {
    UpdateMiniObserver.fire();
    if (previousChannel) {
      nextOptions.source.videoid = previousChannel;
      this.__loadTV(nextOptions, isSourceReplace);
    } else {
      asyncPinObserver.fire('channel_is_blocked');
    }
  }

  /**
   * PGM trae errores? pin parental? bookmark? error general de pgm
   */
  async __handlePGM(pgm, nextOptions, isSourceReplace) {
    // TODO agregar los casos de TV, para ir suscripción!!
    /**
     * Caso particular, cuando el user cambia de lenguage desde un vod single a otro
     * single, al resolver pgm del siguiente contenido se ignorará el initial_playback_seconds
     * cuando nextOptions trae el param resume
     *
     * Esto aplica también al recuperar el playing después de reconexión al perder internet
     */

    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    let pgmToUse = nextOptions.ispip ? this.pgmpip : this.pgm;
    let previousChannel = this.getPreviousChannel(nextOptions, false);

    // Reset de las vars de async pin / live
    this.asyncPinEventsCounter = 0;
    this.asyncPinPreviousChannel = null;
    // ====================

    // CASO 0 (de 4 en total, hasta ahorita)
    if (
      this.playerStreamingUtils.canPlayPGM(
        pgmToUse,
        pgmToUse.entry && pgmToUse.entry.stream_type ? pgmToUse.entry.stream_type : null
      )
    ) {
      // CASO 1
      // Aquí se abre otro condicional *else*, por si habrá tratamiento especial si es que es un replace?
      // por ejemplo si al momento de cambiar de idioma de un single, se vuelve a pedir parental?
      let checkSusc = true;
      if (nextOptions.islive) {
        //Verifica si tiene permisos para playear el canal
        this.playerStreamingUtils.setChangePath(this.callbacks.changePath);
        const isFallback = PlayerHelper.isFallback(null, nextOptions);
        if(!isFallback) {
          checkSusc = await this.playerStreamingUtils.checkSusc(
            pgmToUse,
            pgmToUse.entry.group_id
          );
        }
      }
      if (!checkSusc && !this.playerStreamingUtils.canPlayChannel(previousChannel)) {
        previousChannel = null;
        // Si no esta suscrito, no puede playear canal, tampoco puede playear el canal anterior, se quita loading.
        // Espera por siguiente cambio de canal del user.
        if (this.callbacks.clearLoading && Utils.isFunction(this.callbacks.clearLoading)) {
          this.callbacks.clearLoading();
        }
      }

      if (checkSusc) {
        if (pgmToUse.errors && pgmToUse.errors[0]) {
          let defaultErrorMsg =
            pgmToUse.errors && pgmToUse.errors[0] && pgmToUse.errors[0].message;
          let errorMsg = '';
          if (pgmToUse.errors[0].code) {
            errorMsg = Translator.get(pgmToUse.errors[0].code, '');
          }
          if (errorMsg === '') {
            errorMsg = `${pgmToUse.errors[0].code} ${defaultErrorMsg}`;
          }
          // onreject y onretry se manejan en el video component, yo nomás aviso
          // El component debería de mandar nuevamente todo el ciclo de playing
          let modalData = {
            modalType: MODAL_REINTENTO,
            modalMessage: errorMsg,
            nextOptions: nextOptions,
            isSourceReplace: isSourceReplace,
            pgm: pgmToUse
          };

          if (
            this.callbacks.onResolveShowModal &&
            Utils.isFunction(this.callbacks.onResolveShowModal)
          ) {

            this.callbacks.onResolveShowModal(modalData);
          }
          this.log('Modal getmediaerror ', pgmToUse);
        } else {
          let skipParental = this.__skipPgmValidation(nextOptions);
          let hasPIN = false;

          if (pgmToUse.user && pgmToUse.user.parental_rating) {
            if (pgmToUse.user.parental_rating['requires_validation']) {
              hasPIN = skipParental ? false : true;
            }
          }
          // CASO 2 pin parental
          if (hasPIN && !nextOptions.ispreview) {
            // Si el canal ya fue desbloqueado vía PIN desde MatchDetailVideoPanel, continuar sin pedir PIN
            // (independientemente de si playFromMatchDetail llegó o no en este dispatch)
            const channelGroupId = nextOptions.source && nextOptions.source.videoid
              ? nextOptions.source.videoid.toString()
              : null;
            if (channelGroupId && this._matchDetailUnlockedChannels.has(channelGroupId)) {
              logger.debug('[AAFPlayerMain] Canal ya desbloqueado desde MatchDetail, saltando pin parental:', channelGroupId);
              this._matchDetailUnlockedChannels.delete(channelGroupId);
              this.__checkBookmark(nextOptions, isSourceReplace);
              return;
            }
            // Si el dispatch viene desde MatchDetailVideoPanel, devolver el control
            // al componente para que muestre su propio overlay de bloqueo
            if (nextOptions.playFromMatchDetail) {
              asyncPinObserver.fire('match_detail_channel_requires_pin');
              return;
            }
            const isChangeEpisodeOrLang =
              nextOptions.ischangeepisode || nextOptions.ischangelang;
            this.__checkBookmark = this.__checkBookmark.bind(this);
            if (nextOptions.modalHasBeenShown) {
              let pgmAfterStop = Object.assign({}, pgmToUse);
              this.stopPlayer(nextOptions.ispip, isChangeEpisodeOrLang);
              if (nextOptions.ispip) {
                this.pgmpip = pgmAfterStop;
              } else {
                this.pgm = pgmAfterStop;
              }
              this.__checkBookmark(nextOptions, isSourceReplace);
            } else {
              let modalData = {
                type: MODAL_PIN_CODE_RATING_TYPE,
                modalType: MODAL_PIN,
                pgm: pgmToUse,
                successCallBack: this.__checkBookmark,
                nextOptions: nextOptions,
                isSourceReplace: isSourceReplace,
                failedCallBack: () => {
                  if (nextOptions.islive) {
                    this.playPreviousChannel(
                      previousChannel,
                      nextOptions,
                      isSourceReplace
                    );
                  }
                }
              };
              if (
                this.callbacks.onResolveShowModal &&
                Utils.isFunction(this.callbacks.onResolveShowModal)
              ) {
                this.callbacks.onResolveShowModal(modalData);
              }
              this.log('Pide parental ', pgm);
            }
          } else {
            // Si es startover o catchup se prepara para el async, just in case
            if(nextOptions.streamContentType === constant.AAF_CONTENT_IS_CATCHUP || nextOptions.streamContentType === constant.AAF_CONTENT_IS_STARTOVER) {
              this.__resolveLiveAsyncPin(nextOptions, previousChannel, isSourceReplace);
            }
            this.__checkBookmark(nextOptions, isSourceReplace);
          }
        }
      } else {
        if (previousChannel) {
          if (this.isPinBlocked(previousChannel)) {
            nextOptions.modalHasBeenShown = true;
          }
          this.playPreviousChannel(previousChannel, nextOptions, isSourceReplace);
        }
      }
    }
    // Can play, error
    else {
      let proveedor = PlayerHelper.getProviderFromPgm(pgmToUse);
      let defaultMessage =
        'El proveedor de este contenido no soporta este formato, por favor intenta en alguno de los dispositivos soportados.';

      let message = Translator.get(
        `${proveedor}_videoplayer_unsupported_encoder`,
        defaultMessage
      );

      this.log('Modal oncantplay ', pgmToUse);
      let modalData = {
        modalType: AAF_MODAL_ERROR,
        pgm: pgmToUse,
        modalMessage: message,
        nextOptions: nextOptions,
        callback: () => { }
      };
      if (
        this.callbacks.onResolveShowModal &&
        Utils.isFunction(this.callbacks.onResolveShowModal)
      ) {
        this.callbacks.onResolveShowModal(modalData);
      }
    }
  }

  /**
   * PGM trae errores? pin parental? bookmark? error general de pgm
   */
  async __handleNotPGM(pgm, nextOptions, isSourceReplace) {
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    if (window.performance)
      logger.debug(
        '[TIMEMARK] AAFPlayerMain entrando en  __handleNotPGM ' + window.performance.now()
      );
    // TODO agregar los casos de TV, para ir suscripción!!
    /**
     * Caso particular, cuando el user cambia de lenguage desde un vod single a otro
     * single, al resolver pgm del siguiente contenido se ignorará el initial_playback_seconds
     * cuando nextOptions trae el param resume
     *
     * Esto aplica también al recuperar el playing después de reconexión al perder internet
     */
    let hasPIN = this.isPinBlocked(nextOptions.source.videoid);

    let pgmToUse = nextOptions.ispip ? this.pgmpip : this.pgm;
    let previousChannel = this.getPreviousChannel(nextOptions, hasPIN);
    const isChangeEpisodeOrLang = nextOptions.ischangeepisode || nextOptions.ischangelang;

    // CASO 0 (de 4 en total, hasta ahorita)
    let checkSusc = true;
    if (nextOptions.islive) {
      //Verifica si tiene permisos para playear el canal
      this.playerStreamingUtils.setChangePath(this.callbacks.changePath);

      let nextContentType = PlayerHelper.getContentType(nextOptions);
      const isFallback = PlayerHelper.isFallback(null, nextOptions, nextContentType);
      if (!this.playerStreamingUtils.canPlayChannel(pgmToUse.entry.group_id, isFallback)) {
        checkSusc = await this.playerStreamingUtils.checkSusc(
          pgmToUse,
          pgmToUse.entry.group_id
        );
      }
    }
    if (checkSusc) {
      // CASO 2 pin parental
      if (hasPIN) {
        // && !nextOptions.ispreview (Se asume que se playea en FULL y es live)

        // Reset de las vars de async
        this.asyncPinEventsCounter = 0;
        this.asyncPinPreviousChannel = null;
        // ====================

        if (this.comeFromNonSuscChannel) {
          this.stopPlayer(nextOptions.ispip, isChangeEpisodeOrLang);
          this.pgm = pgmToUse;

          if (pgm.entry.idTPA && typeof pgm.entry.idTPA.type === 'string') {
            this.__continueStartPlayer(nextOptions);
          } else {
            this.__continuePlayer(nextOptions, isSourceReplace);
          }
          this.comeFromNonSuscChannel = false;
        } else {
          if (nextOptions.modalHasBeenShown) {
            this.stopPlayer(nextOptions.ispip, isChangeEpisodeOrLang);
            this.pgm = pgmToUse;

            if (pgm.entry.idTPA && typeof pgm.entry.idTPA.type === 'string') {
              this.__continueStartPlayer(nextOptions);
            } else {
              this.__continuePlayer(nextOptions, isSourceReplace);
            }
          } else {
            let modalData = {
              modalType: MODAL_PIN,
              pgm: pgmToUse,
              successCallBack: () => {
                this.stopPlayer(nextOptions.ispip, isChangeEpisodeOrLang);
                this.pgm = pgmToUse;

                if (pgm.entry.idTPA && typeof pgm.entry.idTPA.type === 'string') {
                  this.__continueStartPlayer(nextOptions);
                } else {
                  this.__continuePlayer(nextOptions, isSourceReplace);
                }
              },
              // Params para el regreso
              nextOptions: nextOptions,
              isSourceReplace: isSourceReplace,
              failedCallBack: () => {
                if (
                  this.callbacks.clearLoading &&
                  Utils.isFunction(this.callbacks.clearLoading)
                ) {
                  this.callbacks.clearLoading(modalData);
                }
                asyncPinObserver.fire('channel_is_blocked');
              }
            };
            if (
              this.callbacks.onResolveShowModal &&
              Utils.isFunction(this.callbacks.onResolveShowModal)
            ) {
              this.callbacks.onResolveShowModal(modalData);
            }
            this.log('Pide parental ', pgm);
          }
        }
      } else {
        this.__resolveLiveAsyncPin(nextOptions, previousChannel, isSourceReplace);

        if (pgm.entry.idTPA && typeof pgm.entry.idTPA.type === 'string') {
          this.__continueStartPlayer(nextOptions);
        } else {
          this.__continuePlayer(nextOptions, isSourceReplace);
        }
      }
    } else {
      if (previousChannel) {
        this.comeFromNonSuscChannel = true;
        this.stopPlayer(nextOptions.ispip, isChangeEpisodeOrLang);
        if (this.isPinBlocked(previousChannel)) {
          nextOptions.modalHasBeenShown = true;
        }
        this.playPreviousChannel(previousChannel, nextOptions, isSourceReplace);
      }
    }
  }

  getPreviousChannel(nextOptions, hasPin) {
    let previousChannel = null;
    if (this.currentChannel === null || this.currentChannel !== nextOptions.source.videoid) {
      previousChannel = this.currentChannel;
      this.currentChannel = hasPin ? this.currentChannel : nextOptions.source.videoid;
    }
    if (!previousChannel) {
      previousChannel = this.getPlayedChannelWithoutPin();
    }
    return previousChannel;
  }

  /**
   *
   * @param {*} who trae valores channel_is_blocked_by_async o player_starts
   */
  __handleAsyncPinObserver(who) {
    logger.debug('[AAF_FWK3] [AAFPLayerMain] entra en __handleAsyncPinObserver, who es: ' + who);
    // Registrar canal desbloqueado desde MatchDetailVideoPanel
    if (typeof who === 'string' && who.startsWith('match_detail_channel_unlocked:')) {
      const unlockedGroupId = who.replace('match_detail_channel_unlocked:', '');
      if (unlockedGroupId) {
        this._matchDetailUnlockedChannels.add(unlockedGroupId);
        logger.debug('[AAFPlayerMain] Canal registrado como desbloqueado desde MatchDetail:', unlockedGroupId);
      }
      return;
    }
    const _waiting_events = ['channel_is_blocked_by_async', 'player_starts'];
    const waiting_events = new Set(_waiting_events);
    if (waiting_events.has(who)) {
      this.asyncPinEventsCounter = this.asyncPinEventsCounter + 1;
    }
    if (this.asyncPinEventsCounter === _waiting_events.length) {
      // Lanzar modal de pin
      //logger.debug('[AAF_FWK2] SE LANZA MODAL PIN @@@@@@@@@@@@@@@@@@@');
      this.playerInstance.pause();
      let modalData = {
        modalType: MODAL_PIN,
        successCallBack: () => {
          //logger.debug('[AAF_FWK2] AAFPlayerMain success pin :V');
          // Hacer resume del playing
          this.playerInstance.resume();
        },
        useAsyncPin: true,
        failedCallBack: () => {
          if (
            this.callbacks.onResolveAsyncPinFailed &&
            Utils.isFunction(this.callbacks.onResolveAsyncPinFailed)
          ) {
            this.callbacks.onResolveAsyncPinFailed(
              this.asyncPinPreviousChannel.nextOptions
            );
          }
        }
      };
      if (
        this.callbacks.onResolveShowModal &&
        Utils.isFunction(this.callbacks.onResolveShowModal)
      ) {
        this.callbacks.onResolveShowModal(modalData);
      }
    }
  }

  /**
   * Por el momento sólo reset del counter
   */
  __prepareAsyncObserver(nextOptions, previousChannel, isSourceReplace) {
    let _nextOptions = Object.assign({}, nextOptions);
    if (_nextOptions.useAsyncPin) {
      delete _nextOptions.useAsyncPin;
    }
    if (_nextOptions.deleteLastStream) {
      delete _nextOptions.deleteLastStream;
    }
    this.asyncPinEventsCounter = 0;
    this.asyncPinPreviousChannel = {
      nextOptions: _nextOptions,
      previousChannel,
      isSourceReplace
    };
  }

  /**
   *
   * @param {*} nextOptions
   *
   * Asumimos, si, asumimos que si hay fallback, al menos el primer fallback
   * va a llegar en 15 segundos, entonces en ese tiempo debió haber llegado la
   * llamada de statuscontrolpin. Si cae en dos fallbacks, entonces el tiempo se
   * duplica y así...statuscontrolpin debe llegar mucho antes
   */
  __resolveLiveAsyncPin(nextOptions, previousChannel, isSourceReplace) {
    logger.debug('[AAF_FWK3] AAFPlayerMain enter __resolveLiveAsyncPin');
    this.__prepareAsyncObserver(nextOptions, previousChannel, isSourceReplace);
    // Si no tiene pin y es live, y se usa el flow de parental rating:
    // verificar por un asyncPin
    let useAsyncPin =
      Utils.isNotNullOrNotUndefined(nextOptions.useAsyncPin) &&
      nextOptions.useAsyncPin === true;
    if (nextOptions.islive && AAF.Pin.useChannelRatingFlow() && useAsyncPin) {
      /**
       * Si usamos el rating flow, hacemos o no el request asíncrono?
       */
      if (AAF.Pin.usePinRequest()) {
        // Pero...debemos esperar por el playing, porque si esta en fallback? no tiene caso mostrar el pin
        // Hasta que este seguro de que realmente se playeará
        AAF.Pin.updateStatusControlPin()
          .then(blockedChannels => {
            logger.debug(
              '[AAF_FWK3] AAFPlayerMain llegó la respuesta del pin, restart event loop de status control pin'
            );
            // Verificar si este canal este bloqueado, y si es así
            // mandar pin parental y poner en pausa, pero esperar por el
            // current playing por si esta esperando en fallback
            //asyncPinObserver.fire('channel_is_blocked_by_async');

            if (nextOptions.source && nextOptions.source.videoid) {
              if (this.isPinBlocked(nextOptions.source.videoid)) {
                asyncPinObserver.fire('channel_is_blocked_by_async');
              }
            }
            AAF.Pin.restartLoopRefreshBlockedChannels();
          })
          .catch(error => {
            // Handling error, por el momento se verá el playing
          });
      }
    }
  }

  __checkBookmark(nextOptions, isSourceReplace) {
    let skipParental = this.__skipPgmValidation(nextOptions);
    let pgmToUse = nextOptions.isPip ? this.pgmpip : this.pgm;

    let initialTime = 0;
    if (!nextOptions.islive && pgmToUse.media && pgmToUse.media.initial_playback_in_seconds) {
      initialTime = pgmToUse.media.initial_playback_in_seconds;
    }

    if (isNaN(initialTime)) {
      initialTime = 0;
    }
    // CASO 3 handle bookmark
    if (initialTime > 0 && !nextOptions.ispreview && !skipParental) {
      this.__handleWithBookmark = this.__handleWithBookmark.bind(this);
      const modalData = {
        modalType: AAF_MODAL_PLAY_OPTIONS,
        successCallBack: this.__handleWithBookmark,
        // Params para el regreso
        nextOptions: nextOptions,
        isSourceReplace: isSourceReplace
      };
      if (
        this.callbacks.onResolveShowModal &&
        Utils.isFunction(this.callbacks.onResolveShowModal)
      ) {
        this.callbacks.onResolveShowModal(modalData);
      }
      this.log('Pide bookmark ', pgmToUse);
    } else {
      if (skipParental) {
        // Aquí ya sé que viene resume en nextOptions
        if (nextOptions.ispip)
          this.pgmpip.media.initial_playback_in_seconds = nextOptions.resume;
        else this.pgm.media.initial_playback_in_seconds = nextOptions.resume;
      }
      this.__continuePlayer(nextOptions, isSourceReplace);
    }
  }

  __handleWithBookmark(resetBookmark, nextOptions, isSourceReplace) {
    if (resetBookmark) {
      if (nextOptions.ispip) this.pgmpip.media.initial_playback_in_seconds = 0;
      else this.pgm.media.initial_playback_in_seconds = 0;
    }
    this.__continuePlayer(nextOptions, isSourceReplace);
  }

  __continuePlayer(nextOptions, isSourceReplace) {
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    if (window.performance)
      logger.debug(
        '[TIMEMARK] AAFPlayerMain entrando en  __continuePlayer ' + window.performance.now()
      );

    if (isSourceReplace) {
      this.__continueReplacePlayer(nextOptions);
    } else {
      this.__continueStartPlayer(nextOptions);
    }
  }

   isForceStopEneabled(){
    return this.forceStopPlayer;
  }

  /**
   * Termina playing
   */
  stopPlayer(ispip = false, isChangeEpisodeOrLang) {
    logger.debug('[AAFPlayerMain] setPlayerState goback en stopPlayer....', ispip);
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: stopPlayer'}`);

    let currentPlayingState;
    if (ispip) {
      currentPlayingState = this.getCurrentPlayingState(true);
    } else {
      currentPlayingState = this.getCurrentPlayingState(false);
    }

    /**
     * Antes de resetear, guardar estado actual del player para enviar notificación a react.
     *
     * getDevicePlayerParams no es necesario guardarlo antes, porque se recupera su valor actual
     * antes de resetarlo.
     */
    const player_current_options = this.getCurrentPlayerOptions(ispip);
    const currentDeviceParams = this.getDevicePlayerParams(ispip);

    let playbackMundialStop = null;
    if(this.mundial2026InputOptions) {
      playbackMundialStop = this.mundial2026InputOptions.playbackData.tracking.urls.stop;
    }

    this.__resetPlaying(ispip);
    if (currentPlayingState === constant.AAFPLAYER_STOP) {
      if(this.isForceStopEneabled()) {
        this.setForceStopPlayer(false)
        this.playerInstance.stopAndQuit();
      }
      return;
    }

    let { playerMedia: { tracking: { urls: { stop = null } = {} } = {} } = {} } = currentDeviceParams;

    // Get current device params
    // Si tiene stop se lanza flag de que lanzará stop
    if (stop || playbackMundialStop) {
      logger.debug('[TSTOP] AAFPlayer main - _stopPlayer, se enviará stop tracking');
      // Hay url de stop, entonces se lanzará el tracking muy probablemente
      stopTrackingObserver.setSendingStop(true);
    }
    else {
      logger.debug('[TSTOP] AAFPlayer main - _stopPlayer, NO** se enviará stop tracking');
      stopTrackingObserver.setSendingStop(false);
    }

    this.__stopCurrentPlay(ispip, isChangeEpisodeOrLang, player_current_options, playbackMundialStop);
    this.setCurrentPlayingState(constant.AAFPLAYER_STOP, ispip);
    this.setCurrentContentType(null, ispip);
    this.setDevicePlayerParams(null, ispip);
    this.setTryingToPlayOptions(null);
  }

  setForceStopPlayer(value){
    this.forceStopPlayer = value;
  }

  __handleAwaitGetMediaObserver() {
    logger.debug('[TSTOP] AAFPlayer main - __handleAwaitGetMediaObserver enter');
    // Rompe el interval y continua con la reproducción
    if (this.awaitGetMediaIntervalID) {
      clearInterval(this.awaitGetMediaIntervalID);
      this.awaitGetMediaIntervalID = null;
    }

    const toPlayArgs = stopTrackingObserver.getParams();
    logger.debug('[TSTOP] AAFPlayer main - __handleAwaitGetMediaObserver toPlayArgs: ', toPlayArgs);

    const { nextOptions, isSourceReplace, stype, npvrStreamType = null } = toPlayArgs;
    this.__continuePlaying(nextOptions, isSourceReplace, stype, npvrStreamType);
    stopTrackingObserver.unsubscribe(this.__handleAwaitGetMediaObserver);
    stopTrackingObserver.setSendingStop(false);
  }

  __stopCurrentPlay(ispip, isChangeEpisodeOrLang = false, player_current_options, playbackMundialStop = null) {
    Utils.resetBackground();
    let currentPlayingState;
    if (ispip) {
      currentPlayingState = this.getCurrentPlayingState(true);
    } else {
      currentPlayingState = this.getCurrentPlayingState(false);
    }
    if (currentPlayingState === constant.AAFPLAYER_STOP) {
      if(this.isForceStopEneabled()) {
        this.setForceStopPlayer(false)
        this.playerInstance.stopAndQuit();
      }
        return;
    }
    // Send callback to stop
    if (
      this.callbacks.onPlayerStopMedia &&
      Utils.isFunction(this.callbacks.onPlayerStopMedia)
    ) {
      this.callbacks.onPlayerStopMedia(
        player_current_options,
        this.getDevicePlayerParams(ispip),
        (player_current_options.streamContentType === constant.AAF_CONTENT_IS_TV ? 0 : this.getCurrentTime()),
        isChangeEpisodeOrLang,
        playbackMundialStop
      );
    }

    if (ispip) this.playerInstancePip.destroy();
    else this.playerInstance.destroy();
  }

  __resetPlaying(ispip) {
    this.audioTracks = [];
    this.audioTracksLoaded = false;
    this.mundial2026InputOptions = null;

    if (ispip) {
      this.currentContentTypePip = null;
      this.devicePlayerParamsPip = null;
      this.playerOptionsPip = null;
      this.pgmpip = null;
    } else {
      this.currentContentType = null;
      this.devicePlayerParams = null;
      this.playerOptions = null;
      this.pgm = null;
    }
    this.timeShift = null;
    this.creditsTime = 0;
    this.isEndPlayer = false;
  }

  __sendToPlay(options) {
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${options && options.streamContentType ? 'Content_type: ' + options.streamContentType :''} ${options && options.groupId ? 'Gid: '+ options.groupId :'' }`);

    if (window.performance)
      logger.debug(
        '[TIMEMARK] AAFPlayerMain entrando en  __sendToPlay ' + window.performance.now()
      );
    this.log('Params to send start* to player ', options);
    // Add callbacks
    options.events = this.bindedevents;
    if (window.performance) {
      let entC = window.performance.now();
      logger.debug(
        'INICIOPLAY NEXTPLAYERSTATE resuelve: ' +
        (entC - window.INICIONEXTPLAYERSTATE) +
        'ms'
      );
      window.INICIOANDROIDPLAYER = window.performance.now();
    }

    // create media toma precaución del pip o full, y ya va en options params
    if (options.isPip) {
      this.playerInstancePip.createMedia(options);
      this.playerInstancePip.loadMedia();
    } else {
      this.playerInstance.createMedia(options);
      if (!options.isTPA) this.playerInstance.loadMedia();
    }
    asyncPinObserver.fire('player-load-media');

    if (window.performance) {
      logger.debug(
        '[TIMEMARK] AAFPlayerMain terminado en  __sendToPlay ' + window.performance.now()
      );

      let entB = window.performance.now();
      logger.debug(
        'INICIOPLAY TERMINA LOAD PLAAY: ' + (entB - window.INICIOANDROIDPLAYER) + 'ms'
      );
    }

    // El play inicial se manda desde AAFPlayer onresolve
  }

  __sendReplaceToPlay(options) {
    this.log('Params to send replace* to player ', options);
    // Add callbacks
    options.events = this.bindedevents;
    if (options.isPip) {
      // create media toma precaución del pip o full, y ya va en options params
      this.playerInstancePip.replaceMediaSource(options);
    } else {
      // create media toma precaución del pip o full, y ya va en options params
      this.playerInstance.replaceMediaSource(options);
    }
    //Al ser replace, el play inicial se manda desde device al hacer el replace
  }

  async __resolvePlayerParams(nextOptions, isSourceReplace) {
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    if (window.performance) {
      logger.debug(
        '[TIMEMARK] AAFPlayerMain entrando en  __resolvePlayerParams ' +
        window.performance.now()
      );
    }
    let nextContentType = PlayerHelper.getContentType(nextOptions);
    switch (nextContentType) {
      case constant.AAF_CONTENT_IS_NPVR:
        nextOptions.streamContentType = constant.AAF_CONTENT_IS_NPVR;
        await this.__loadNPVR(nextOptions, isSourceReplace);
        break;
      case constant.AAF_CONTENT_IS_VOD:
        nextOptions.streamContentType = constant.AAF_CONTENT_IS_VOD;
        await this.__loadVOD(nextOptions, isSourceReplace);
        break;
      case constant.AAF_CONTENT_IS_TV:
        nextOptions.streamContentType = constant.AAF_CONTENT_IS_TV;
        await this.__loadTV(nextOptions, isSourceReplace);
        break;
      case constant.AAF_CONTENT_IS_TIMESHIFT:
        nextOptions.streamContentType = constant.AAF_CONTENT_IS_TIMESHIFT;
        await this.__loadTimeshift(nextOptions, isSourceReplace);
        break;
      case constant.AAF_CONTENT_IS_CATCHUP:
        nextOptions.streamContentType = constant.AAF_CONTENT_IS_CATCHUP;
        await this.__loadCatchup(nextOptions, isSourceReplace);
        break;
      case constant.AAF_CONTENT_IS_STARTOVER:
        nextOptions.streamContentType = constant.AAF_CONTENT_IS_STARTOVER;
        await this.__loadCatchup(nextOptions, isSourceReplace);
        break;
      case constant.AAF_CONTENT_IS_AUDIO:
        nextOptions.streamContentType = constant.AAF_CONTENT_IS_AUDIO;
        this.__loadAudio(nextOptions, isSourceReplace);
        break;
      case constant.AAF_CONTENT_IS_RADIO:
        nextOptions.streamContentType = constant.AAF_CONTENT_IS_RADIO;
        this.__loadRadio(nextOptions, isSourceReplace);
        break;
      default:
        break;
    }
  }

  async __continueLoadNPVR(nextOptions, isSourceReplace, npvrStreamType) {
    logger.debug('[TSTOP] AAFPlayer main - __continueLoadNPVR enter');

    const playerGetMediaTask = new SimpleGetRequestTask(
      nextOptions.source.videosource,
      null,
      true,
      true
    );
    const pgm = await RequestManager.addRequest(playerGetMediaTask);
    if (pgm.errors && pgm.errors[0] && pgm.errors[0].message) {
      let msg = pgm.errors[0].message;
      if (pgm.errors[0].code) {
        msg = msg + ' (' + pgm.errors[0].code + ')';
      }

      const modalParams = {
        callback: null,
        modalMessage: msg,
        modalType: AAF_MODAL_ERROR
      };
      if (
        this.callbacks.onResolveShowModal &&
        Utils.isFunction(this.callbacks.onResolveShowModal)
      ) {
        this.callbacks.onResolveShowModal(modalParams);
      }
    } else {
      this.pgm = pgm.response;

      const videoURL = (this.pgm.media && this.pgm.media.video_url);
      if (videoURL) {
        let url = videoURL;
        const unsupportedDevice = Utils.isSamsungOrsay() || Utils.isPlaystation4() || Utils.isTizenLegacy();
        if (unsupportedDevice) {
          const videoURLencode= encodeURIComponent(videoURL);
          url = `${getAppConfig().end_point_middleware}checkUrl?url=${videoURLencode}`;
        }
        const responseURL = await this.checkVideoURL(url, unsupportedDevice);
        if (responseURL) this.pgm.media.video_url = responseURL;
      }

      if(pgm && pgm.entry) {
        this.pgm.entry = pgm.entry;
      }

      if (isSourceReplace) {
        this.__continueReplacePlayer(nextOptions); //TODO cuando tengamos la api de recordings/list para NPVR funcionando implementar el caso __continueReplacePlayer
      } else {
        this.__continueStartPlayer(
          nextOptions,
          npvrStreamType ? npvrStreamType : 'smooth_streaming'
        ); //por ahora la implementación solo smooth_streaming ya que url ya construida a player/getmedia no viene mucha informacion
      }
    }
  }

  async __loadNPVR(nextOptions, isSourceReplace) {
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    logger.debug('[TSTOP] AAFPlayer main - __loadNPVR enter');
    let npvrStreamType = null;
    /**
     * NPVR / recording considera que viene el url para playing
     */
    if (nextOptions.source.videosource) {
      // Se hace el replace de la url por la soportada para npvr
      if (Utils.isNotNullOrNotUndefined(nextOptions.videosourceoptions)) {
        let supported_stream_types = Utils.getApaSupportedStream(this.platform, null, null);
        if (
          Utils.isObject(supported_stream_types) &&
          supported_stream_types['npvr'] &&
          Array.isArray(supported_stream_types['npvr']) &&
          supported_stream_types['npvr'][0]
        ) {
          if (
            Utils.isNotNullOrNotUndefined(
              nextOptions.videosourceoptions[supported_stream_types['npvr'][0]]
            )
          ) {
            npvrStreamType = supported_stream_types['npvr'][0];
            nextOptions.source.videosource =
              nextOptions.videosourceoptions[supported_stream_types['npvr'][0]];
          }
        }
      }

      this.__awaitGetMedia(nextOptions, isSourceReplace, 'npvr', npvrStreamType);
    }
  }

  async __continueLoadVOD(nextOptions, isSourceReplace) {
    logger.debug('[TSTOP] AAFPlayer main - __continueLoadVOD enter');
    let pgmr = await this.__getDataPlaying(
      nextOptions,
      nextOptions.source.videoid,
      nextOptions.ispreview,
      nextOptions.islive,
      isSourceReplace
    );
    this.playingVodInProcess = false;
    if (nextOptions.ispip) {
      let pgmrp = {};
      Object.assign(pgmrp, pgmr);
      this.pgmpip = pgmrp;
    } else {
      let pgmrr = {};
      Object.assign(pgmrr, pgmr);
      this.pgm = pgmrr;
    }

    this.__handlePGM(pgmr, nextOptions, isSourceReplace);
  }

  async __loadVOD(nextOptions, isSourceReplace) {
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    showSpinner(true);

    logger.debug('[TSTOP] AAFPlayer main - __loadVOD enter');
    // Piroridad, revisar primero por el id, luego videosource
    if (nextOptions.source.videoid) {
      this.__awaitGetMedia(nextOptions, isSourceReplace, 'vod');
    } else if (nextOptions.source.videosource) {
      let streamType = nextOptions.source && nextOptions.source.streamType;
      if (!streamType) {
        // Se intenta recuperar algun tipo de stream
        streamType = PlayerHelper.getVideoType(nextOptions.source.videosource);
      }

      let supported_stream_types = Utils.getApaSupportedStream(this.platform);
      let supportedStreams = supported_stream_types['vod'].filter(
        stream => !stream.includes(settings.prepend_multiple)
      );

      let support = supportedStreams.find(stream => stream == streamType);

      if (!support) {
        this.__onErrorResolve(
          onResolvePlayingError,
          'Error al obtener streamType en VOD, sólo hay videosource',
          nextOptions
        );
      } else {
        if (nextOptions.ispip) {
          this.pgmpip = {
            media: {
              video_url: nextOptions.source.videosource,
              streamType: streamType
            }
          };
        } else {
          this.pgm = {
            media: {
              video_url: nextOptions.source.videosource,
              streamType: streamType
            }
          };
        }

        if (isSourceReplace) {
          await this.__continueReplacePlayer(nextOptions);
        } else {
          await this.__continueStartPlayer(nextOptions);
        }
      }
    } else {
      this.__onErrorResolve(
        onResolvePlayingError,
        'Error al intentar reproducir VOD, no hay videosource ni videoid',
        nextOptions
      );
    }
  }

  isPinBlocked(groupId) {
    const { pin_channel } = store.getState().pinCodes;
    const blockedChannelsArray = pin_channel.info ? pin_channel.info : []; //channelBlockedUtil.get('blockedChannels');
    return Array.isArray(blockedChannelsArray) && groupId && blockedChannelsArray.includes(groupId.toString());
  }

  async __continueLoadTV(nextOptions, isSourceReplace) {
    logger.debug('[TSTOP] AAFPlayer main - __continueLoadTV enter');
    let pgmr = await this.__getDataPlaying(
      nextOptions,
      nextOptions.source.videoid,
      nextOptions.ispreview,
      nextOptions.islive,
      isSourceReplace
    );
    if (nextOptions.ispip) {
      let pgmrp = {};
      Object.assign(pgmrp, pgmr);
      this.pgmpip = pgmrp;
    } else {
      let pgmrr = {};
      Object.assign(pgmrr, pgmr);
      this.pgm = pgmrr;
      //this.lastStreamTypeUsed = this.pgm.entry.stream_type;
      //console.error('[ANDROID+++] se resuelve siguiente channel por GET_MEDIA', this.pgm);
    }
    this.__handlePGM(pgmr, nextOptions, isSourceReplace);
  }

  async __loadTV(nextOptions, isSourceReplace) {
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    logger.debug('[TSTOP] AAFPlayer main - __loadTV enter');
    if (window.performance) {
      logger.debug(
        '[TIMEMARK] AAFPlayerMain entrando en  __loadTV ' + window.performance.now()
      );
    }

    if (nextOptions.isTPA) {
      NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __loadTV'} ${'TPA: '+ nextOptions.isTPA.type} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);
      this.pgm = {
        media: {
          video_url: null,
          streamType: constant.AAF_CONTENT_IS_TV,
          groupId: nextOptions.source.videoid,
          proveedor: null,
          epgurlresolved: true,
          server_url: null,
          challenge: null,
          certificate_url: null,
        },
        entry: {
          stream_type: constant.AAF_CONTENT_IS_TV,
          group_id: nextOptions.source.videoid,
          idTPA: nextOptions.isTPA,
        }
      }

      this.__handleNotPGM(this.pgm, nextOptions, isSourceReplace);
    }
    else {
    // Casos particulares, en estos casos lo que deben enviar de opciones para playing es el videosource
    // con la url de octoshape, dvbc, dvbs:
    // - nagra, iwedia por coaxial (satelite, cable)
    // - android udp, octoshape, octoshape sólo es para TV-live

    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __loadTV'} ${'TPA: N/A'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    let device_config = Device.getDevice().getConfig();
    let supported_stream_types = Utils.getApaSupportedStream(
      this.platform,
      true,
      nextOptions.source.videoid,
      nextOptions.islive
    );

    if (/*this.lastStreamTypeUsed && */ nextOptions.deleteLastStream) {
      // console.error('=================================> [AAF] [AAFPlayerMain] resolviendo lastStreamTypeUsed ', lastStreamType);
      // console.error('=================================> [AAF] [AAFPlayerMain] entra en this.lastStreamTypeUsed && nextOptions.deleteLastStream ', this.lastStreamTypeUsed, nextOptions.deleteLastStream);
      //let supported_stream_types_temp = supported_stream_types['live'].filter(stream => stream !== this.lastStreamTypeUsed);
      let supported_stream_types_temp = Utils.subtractionArrays(
        supported_stream_types['live'],
        nextOptions.deleteLastStream
      ); //supported_stream_types['live'].filter(stream => stream !== this.lastStreamTypeUsed);
      if (supported_stream_types_temp.length == 0) {
        //this.__onErrorResolve(onResolvePlayingError, 'Fatal error, por favor reinicia el dispositivo ', nextOptions);
      }
      supported_stream_types['live'] = supported_stream_types_temp;
      nextOptions.supported_stream_types = supported_stream_types;
    }
    // Revisar por udp, si es udp y ya tenemos la url, no llamar PGM)
    // TODO se conserva el group id, para actualizar EPG
    // Qué pasará con contenidos con control parental?
    if (nextOptions.source.videoid) {
      let channel_url_data = PlayerHelper.getLiveURL(
        nextOptions.source.videoid,
        supported_stream_types['live']
      );

      //console.info('================================> [AAF] [AAFPlayerMain] se resuelve por fastPlay channel_url_data: ', channel_url_data);
      // Si hay url, se cambia la url de playing
      if (channel_url_data && channel_url_data.live_url) {
        //this.lastStreamTypeUsed = channel_url_data.streamType;
        //console.error('[ANDROID+++] se resuelve siguiente channel por URL de FAST_PLAY, channel_url_data.streamType:::::::: ', channel_url_data.streamType);
        //console.info(channel_url_data);
        NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __loadTV'} ${'IsFastPlay: '+ channel_url_data} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

        logger.info('[TSTOP] se resuelve por fast');
        nextOptions.backgroundimage = channel_url_data.background;
        if (nextOptions.ispip) {
          this.pgmpip = {
            media: {
              video_url: channel_url_data.live_url,
              streamType: channel_url_data.streamType,
              groupId: nextOptions.source.videoid,
              epgurlresolved: true,
              proveedor: channel_url_data.proveedor
            },
            entry: {
              stream_type: channel_url_data.streamType,
              group_id: nextOptions.source.videoid
            }
          };
        } else {
          this.pgm = {
            media: {
              video_url: channel_url_data.live_url,
              streamType: channel_url_data.streamType,
              groupId: nextOptions.source.videoid,
              proveedor: channel_url_data.proveedor,
              epgurlresolved: true, // bandera para indicar en video component que resolvimos con url desde epg/channel
              // JORGE: aquí se deben agregar los parámetros de server_url, challenge, certificate_url
              server_url: channel_url_data.server_url,
              challenge: channel_url_data.challenge,
              certificate_url: channel_url_data.certificate_url
            },
            entry: {
              stream_type: channel_url_data.streamType,
              group_id: nextOptions.source.videoid
            }
          };
        }
        if (isSourceReplace) {
          this.__continueReplacePlayer(nextOptions);
        } else {
          this.__handleNotPGM(this.pgm, nextOptions, isSourceReplace);
        }
      } else {
        NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __loadTV'} ${'NotFastPlay'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

        let isChangeEpisodeOrLang = nextOptions.ischangeepisode || nextOptions.ischangelang;
        if (!nextOptions.hasBeenStopped && !nextOptions.modalHasBeenShown) {
          // Esto pasaría en caso de no hacer stop antes de reproducir un VOD y estando en livePip
          this.stopPlayer(nextOptions.ispip, isChangeEpisodeOrLang);
        }
        this.__awaitGetMedia(nextOptions, isSourceReplace, 'live');
      }
    } else if (nextOptions.source.videosource) {
      let streamType = nextOptions.source && nextOptions.source.streamType;
      if (!streamType) {
        // Se intenta recuperar algun tipo de stream
        streamType = PlayerHelper.getVideoType(nextOptions.source.videosource);
      }

      let supportedStreams = supported_stream_types['vod'].filter(
        stream => !stream.includes(settings.prepend_multiple)
      );
      let support = supportedStreams.find(stream => stream == streamType);

      if (!support) {
        NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __loadTV'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' } ${'Error Message: Error al obtener streamType en VOD, sólo hay videosource'}`);
        this.__onErrorResolve(
          onResolvePlayingError,
          'Error al obtener streamType en VOD, sólo hay videosource',
          nextOptions
        );
      } else {
        if (nextOptions.ispip) {
          this.pgmpip = {
            media: {
              video_url: nextOptions.source.videosource,
              streamType: streamType
            }
          };
        } else {
          this.pgm = {
            media: {
              video_url: nextOptions.source.videosource,
              streamType: streamType
            }
          };
        }
        if (isSourceReplace) {
          this.__continueReplacePlayer(nextOptions);
        } else {
          this.__continueStartPlayer(nextOptions);
        }
      }
    } else {
        NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __loadTV'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' } ${'Error Message: Error al intentar reproducir VOD, no hay videosource ni videoid'}`);
      this.__onErrorResolve(
        onResolvePlayingError,
        'Error al intentar reproducir VOD, no hay videosource ni videoid',
        nextOptions
      );
    }
  }
  }

  /**
   * SOLO PARA DEBUG DE POST
   */
  testpost() {
    logger.debug('[PS4TSH] enter testpost');
    let i_url =
      'http://mfwkconsoleplaystation-api.clarovideo.net/services/player/getmedia?group_id=771505&stream_type=smooth_streaming&preview=0&HKS=r20ga1a69309elq9f7ge39jlr6&api_version=v5.8&authpn=amco&authpt=12e4i8l6a581a&device_category=console&device_manufacturer=playstation&device_model=ps4&device_type=ps4&device_id=a017374b-64fe-7791-16cb-d25087b5c248&device_name=ps4&device_so=freebsd&region=mexico&format=json';
    let i_data = 'name=parampau';
    // The parameters we are gonna pass to the fetch function
    let fetchData = {
      method: 'POST',
      body: i_data,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    };
    fetch(i_url, fetchData)
      .then(function (rep) {
        logger.debug('[PS4TSH] ', rep);
      })
      .catch(err => {
        logger.debug('[PS4TSH] ', err);
      });
  }

  async __continueLoadTimeshift(nextOptions, isSourceReplace) {
    logger.debug('[TSTOP] AAFPlayer main - __continueLoadTimeshift enter');
    let pgmr = await this.__getDataPlaying(
      nextOptions,
      nextOptions.source.videoid,
      nextOptions.ispreview,
      nextOptions.islive,
      isSourceReplace
    );
    if (nextOptions.ispip) {
      let pgmrp = {};
      Object.assign(pgmrp, pgmr);
      this.pgmpip = pgmrp;
    } else {
      let pgmrr = {};
      Object.assign(pgmrr, pgmr);
      this.pgm = pgmrr;
    }
    this.__handlePGM(pgmr, nextOptions, isSourceReplace);
  }

  async __loadTimeshift(nextOptions, isSourceReplace) {
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    logger.debug('[TSTOP] AAFPlayer main - __loadTimeshift enter');
    let supported_stream_types = Utils.getApaSupportedStream(this.platform);
    // Piroridad, revisar primero por el id, luego videosource
    if (nextOptions.source.videoid) {
      this.__awaitGetMedia(nextOptions, isSourceReplace, 'timeshift');
    } else if (nextOptions.source.videosource) {
      let streamType = nextOptions.source && nextOptions.source.streamType;
      if (!streamType) {
        // Se intenta recuperar algun tipo de stream
        streamType = PlayerHelper.getVideoType(nextOptions.source.videosource);
      }
      let supportedStreams = supported_stream_types['timeshift'].filter(
        stream => !stream.includes(settings.prepend_multiple)
      );
      let support = supportedStreams.find(stream => stream == streamType);

      if (!support) {
        this.__onErrorResolve(
          onResolvePlayingError,
          'Error al obtener streamType en VOD, sólo hay videosource',
          nextOptions
        );
      } else {
        if (nextOptions.ispip) {
          this.pgmpip = {
            media: {
              video_url: nextOptions.source.videosource,
              streamType: streamType
            }
          };
        } else {
          this.pgm = {
            media: {
              video_url: nextOptions.source.videosource,
              streamType: streamType
            }
          };
        }
        if (isSourceReplace) {
          this.__continueReplacePlayer(nextOptions);
        } else {
          this.__continueStartPlayer(nextOptions);
        }
      }
    } else {
      this.__onErrorResolve(
        onResolvePlayingError,
        'Error al intentar reproducir VOD, no hay videosource ni videoid',
        nextOptions
      );
    }
  }

  async __continueLoadCatchup(nextOptions, isSourceReplace) {
    logger.debug('[TSTOP] AAFPlayer main - __loadCatchup enter');

    let pgmr = await this.__getDataPlaying(
      nextOptions,
      nextOptions.source.videoid,
      nextOptions.ispreview,
      nextOptions.islive,
      isSourceReplace
    );
    if (nextOptions.ispip) {
      let pgmrp = {};
      Object.assign(pgmrp, pgmr);
      this.pgmpip = pgmrp;
    } else {
      let pgmrr = {};
      Object.assign(pgmrr, pgmr);
      this.pgm = pgmrr;
    }
    this.__handlePGM(pgmr, nextOptions, isSourceReplace);
  }

  async __loadCatchup(nextOptions, isSourceReplace) {
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    logger.debug('[TSTOP] AAFPlayer main - __loadCatchup enter');

    let supported_stream_types = Utils.getApaSupportedStream(this.platform);
    // Piroridad, revisar primero por el id, luego videosource
    if (nextOptions.source.videoid) {
      this.__awaitGetMedia(nextOptions, isSourceReplace, 'catchup');
    } else if (nextOptions.source.videosource) {
      let streamType = nextOptions.source && nextOptions.source.streamType;
      if (!streamType) {
        // Se intenta recuperar algun tipo de stream
        streamType = PlayerHelper.getVideoType(nextOptions.source.videosource);
      }
      let supportedStreams = supported_stream_types['vod'].filter(
        stream => !stream.includes(settings.prepend_multiple)
      );
      let support = supportedStreams.find(stream => stream == streamType);

      if (!support) {
        this.__onErrorResolve(
          onResolvePlayingError,
          'Error al obtener streamType en VOD, sólo hay videosource',
          nextOptions
        );
      } else {
        if (nextOptions.ispip) {
          this.pgmpip = {
            media: {
              video_url: nextOptions.source.videosource,
              streamType: streamType
            }
          };
        } else {
          this.pgm = {
            media: {
              video_url: nextOptions.source.videosource,
              streamType: streamType
            }
          };
        }
        if (isSourceReplace) {
          this.__continueReplacePlayer(nextOptions);
        } else {
          this.__continueStartPlayer(nextOptions);
        }
      }
    } else {
      this.__onErrorResolve(
        onResolvePlayingError,
        'Error al intentar reproducir VOD, no hay videosource ni videoid',
        nextOptions
      );
    }
  }

  __loadAudio(nextOptions, isSourceReplace) {
    this.__loadAudioRadio(nextOptions, isSourceReplace);
  }

  __loadRadio(nextOptions, isSourceReplace) {
    this.__loadAudioRadio(nextOptions);
  }

  __loadAudioRadio(nextOptions, isSourceReplace) {
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    let playerParams = this.__getAudioParams(nextOptions);
    if (isSourceReplace) {
      this.__sendReplaceToPlay(playerParams);
    }
    // TODO funciona replace en música
    else {
      this.__sendToPlay(playerParams);
    }
    // Update internal
    this.setDevicePlayerParams(playerParams, false);
    // Actualizar estado interno, hasta el final, después de que realmente no haya error
    let nextContentType = PlayerHelper.getContentType(nextOptions);
    this.setCurrentPlayerOptions(nextOptions, false);
    this.setCurrentPlayingState(constant.AAFPLAYER_PLAY);
    this.setCurrentContentType(nextContentType);

    if (this.callbacks.onResolveParams) {
      this.callbacks.onResolveParams(
        playerParams,
        this.getCurrentPlayerOptions(false),
        false
      );
    }
  }

  isHBOLiveref(nextOptions) {
    const liveref = (nextOptions && nextOptions.npvrEvent && nextOptions.npvrEvent.liveref);
    return typeof liveref === 'string' && liveref.toLowerCase().includes('hbo');
  }

  // TBRFRE-1792 (7.2.2): el flujo de activación de HBO Max NO debe dispararse
  // cuando el usuario cambia de canal con CH+/CH-.
  isChannelUpDownNavigation(nextOptions) {
    return Boolean(nextOptions && nextOptions.fromChannelUpDown);
  }

  // Perfil admin, con suscripción HBO y estado pendiente/sin vincular
  canShowHBOActivationModal() {
    const { user = {} } = store.getState() || {};
    const hasHBOSubscription = user && user.superhighlight && user.superhighlight.includes(HBO_SUBSCRIPTION);
    const isProfileAdmin = user && user.admin;
    const statusHBO = user && user.statusHBO;
    return Boolean(hasHBOSubscription && isProfileAdmin && (statusHBO === UNLINKED || statusHBO === PENDING));
  }

  showHBOActivationModal(data) {
    const modal = {
      modalType: AAF_MODAL_INICIAL_ACTIVA_HBO_MAX,
      modalProps: {
        data
      }
    };
    setTimeout(() => {
      store.dispatch(showModal(modal));
    }, HBO_ACTIVATION_MODAL_DELAY_MS);
  }

  __getVideoParams(nextOptions, pgm) {
    let nextContentType = PlayerHelper.getContentType(nextOptions);
    let video_url = pgm.media && pgm.media.video_url;
    let server_url = pgm.media && pgm.media.server_url;
    let challenge = pgm.media && pgm.media.challenge;
    let certificate = pgm.media && pgm.media.certificate_url;
    let resultCert = pgm.media && pgm.media.resultCert;
    const config = getAppConfig();
    if (PlayerHelper.getContentType(nextOptions) === constant.AAF_CONTENT_IS_NPVR) {
      //caso NPVR
      if (this.isHBOLiveref(nextOptions) && this.canShowHBOActivationModal()) {
        const data = {
          format_types: null,
          episode_number: null,
          season_number: null,
          provider: nextOptions && nextOptions.npvrEvent && nextOptions.npvrEvent.liveref || null,
          index: null,
          content_list: null,
          content_list_id: null,
          group_id: pgm && pgm.group && pgm.group.common && pgm.group.common.id || null,
          title: pgm && pgm.group && pgm.group.common && pgm.group.common.title || null
        }
        this.showHBOActivationModal(data);
      }
      return {
        src:
          this.platform !== 'workstation'
            ? video_url
            : 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4?t=' +
            Math.random(),
        //src: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4?t=" + Math.random(),
        controls: true,
        muted: false,
        drmInfo: {
          server_url: server_url,
          challenge: challenge ? challenge : null,
          content_id: pgm.media.content_id ? pgm.media.content_id : null,
          device_id: config.device_id,
          certificate_url: certificate,
          resultCert
        },
        autoPlay: true,
        isLive: false,
        groupId: null,
        streamType: pgm.media.streamType,
        resume: 0,
        backgroundImage: nextOptions.backgroundimage ? nextOptions.backgroundimage : null,
        isTrailer: nextOptions.ispreview,
        creditsTime: null,
        shortLanguageOptions: null,
        extendedCommonLangOptions: null, //  pgm options langs (for choose lang by user)
        multipleLangOptions: null, // pgm media.languages options, to set audio/subtitle tracks
        provider: null,
        // TODO checar con android si realmente necesitan pgm
        playerMedia: pgm,
        isPip: nextOptions.ispip,
        parentWrapper: this.wrapperContainer,
        streamContentType: nextOptions.streamContentType
          ? nextOptions.streamContentType
          : null,
        isTPA: nextOptions.isTPA ? nextOptions.isTPA : null,
        isFallback: nextOptions.isFallback
      };
    }

    // Prioridad es el resume que venga en e dispatch
    // resume viene en nextOptions, se sobreescribe, por si viene de un network disconnect

    let resume =
      nextOptions && Utils.isNullOrUndefined(nextOptions.resume) ? null : nextOptions.resume;

    // No viene? viene resume en pgm?
    // Es probable que en este punto ya venga resume === initial_playback_in_seconds
    // porque el user pidió cambio de lang en single sobre single arriba se reemplaza
    // initial playback por el valor en resume
    if (resume === null) {
      resume = pgm.media && pgm.media.initial_playback_in_seconds;
      if (isNaN(resume)) {
        resume = 0;
      }
    }

    // Viene data desde pgm?
    let groupId = null;
    if (pgm.group && pgm.group.common) {
      const common = pgm.group.common;
      groupId = common.id ? common.id : pgm.groupId ? pgm.groupId : null;
      const { media } = common.extendedcommon;
      this.imageBackGround = common.image_background
        ? common.image_background
        : nextOptions.backgroundimage
          ? nextOptions.backgroundimage
          : null;
      if (pgm.group.common.image_large)
        pgm.group.common.image_large = common.image_background;
      if (
        pgm.group.common.extendedcommon &&
        pgm.group.common.extendedcommon.media &&
        pgm.group.common.extendedcommon.media.serie &&
        pgm.group.common.extendedcommon.media.serie.image_background
      )
        pgm.group.common.extendedcommon.media.serie.image_large = common.image_background;

      // Si el contenido es catchup o vod se forza a que sea isLive=false (en catchup media.islive = 1)
      let isLive =
        nextContentType === constant.AAF_CONTENT_IS_VOD ||
        nextContentType === constant.AAF_CONTENT_IS_CATCHUP
          ? false
          : media.islive == '1';

      if (nextOptions && nextOptions.isStartOver === true) {
        isLive = true;
      }

      const creditsTime = nextOptions.ispreview ? null : media.rollingcreditstime;
      const contentId = pgm.media.content_id;
      const provider = media.proveedor.nombre;

      if (isLive && provider === 'HBO' && this.canShowHBOActivationModal() && !this.isChannelUpDownNavigation(nextOptions)) {
        const data = {
          format_types: null,
          episode_number: null,
          season_number: null,
          provider: provider || null,
          index: null,
          content_list: null,
          content_list_id: null,
          group_id: contentId || null,
          title: pgm && pgm.group && pgm.group.common && pgm.group.common.title || null
        }
        this.showHBOActivationModal(data);
      }

      // audio && subtitles availables for this content, to fill modal/combo to select audio/sub
      let extendedCommonLangOptions = null;
      if (
        MultipleLangLive.isEnabled() &&
        (isLive || nextContentType === constant.AAF_CONTENT_IS_CATCHUP)
      ) {
        extendedCommonLangOptions = this.playerStreamingUtils.getLangComboLive(
          pgm.entry.group_id,
          pgm.entry.stream_type
        );
      } else {
        extendedCommonLangOptions = this.playerStreamingUtils.getLangCombo(
          pgm.group.common.extendedcommon.media.language.options.option
        );
      }

      // de aquí se saca el is_current si es que se necesita
      const shortLanguageOptions = pgm.language.options;

      // audio && subtitles to set when user select some audio && subtitle, to know what to start
      // subtitles parser or change audioTrack when multiple
      let multipleLangOptions = {};
      if (pgm.media.subtitles) {
        multipleLangOptions.subtitles = pgm.media.subtitles;
      }
      if (pgm.media.audio) {
        multipleLangOptions.audio = pgm.media.audio;
      }
      /*
      if(!this.config.next && pgm.next_group) {
          this.config.next = pgm.next_group.common;
      }
      */

      return {
        src:
          this.platform !== 'workstation'
            ? video_url
            : 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4?t=' +
            Math.random(),
        //src: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4?t=" + Math.random(),
        controls: true,
        muted: false,
        drmInfo: {
          server_url: server_url,
          challenge: challenge ? challenge : null,
          content_id: pgm.media.content_id ? pgm.media.content_id : null,
          device_id: config.device_id,
          certificate_url: certificate,
          resultCert
        },
        autoPlay: true,
        isLive,
        groupId,
        streamType: pgm.media.streamType,
        resume,
        backgroundImage: common.image_background
          ? common.image_background
          : nextOptions.backgroundimage
            ? nextOptions.backgroundimage
            : null,
        isTrailer: nextOptions.ispreview,
        creditsTime: creditsTime,
        shortLanguageOptions,
        extendedCommonLangOptions, //  pgm options langs (for choose lang by user)
        multipleLangOptions, // pgm media.languages options, to set audio/subtitle tracks
        provider,
        // TODO checar con android si realmente necesitan pgm
        playerMedia: pgm,
        isPip: nextOptions.ispip,
        parentWrapper: this.wrapperContainer,
        recommendations: nextOptions.ispip
          ? []
          : nextOptions.recommendations
            ? nextOptions.recommendations
            : [],
        timeshiftData: nextOptions.timeshiftData ? nextOptions.timeshiftData : null,
        streamContentType: nextOptions.streamContentType
          ? nextOptions.streamContentType
          : null,
        isStartOver:
          nextOptions.isStartOver && nextOptions.isStartOver === true ? true : false,
        isTPA: nextOptions.isTPA ? nextOptions.isTPA : null,
        isFallback: nextOptions.isFallback
      };
    } else {
      groupId = pgm.media && pgm.media.groupId ? pgm.media.groupId : null;


      let isLive = nextOptions.islive;
      if (nextOptions && nextOptions.isStartOver === true) {
        isLive = true;
      }

      let extendedCommonLangOptionsLang = null;
      if (
        MultipleLangLive.isEnabled() && (
          nextContentType === constant.AAF_CONTENT_IS_TV
        )
      ) {
        extendedCommonLangOptionsLang = this.playerStreamingUtils.getLangComboLive(
          pgm.entry.group_id,
          pgm.entry.stream_type
        );
      }

      return {
        src:
          this.platform !== 'workstation'
            ? video_url
            : 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4?t=' +
            Math.random(),
        controls: true,
        muted: false,
        drmInfo: {
          server_url: server_url,
          challenge: challenge ? challenge : null,
          content_id: pgm.media.content_id ? pgm.media.content_id : null,
          device_id: config.device_id,
          certificate_url: certificate,
          resultCert
        },
        autoPlay: true,
        isLive,
        groupId,
        streamType: pgm.media.streamType,
        resume: 0,
        backgroundImage: nextOptions.backgroundimage ? nextOptions.backgroundimage : null,
        isTrailer: nextOptions.ispreview,
        creditsTime: null,
        shortLanguageOptions: null,
        extendedCommonLangOptions: extendedCommonLangOptionsLang, //  pgm options langs (for choose lang by user)
        multipleLangOptions: null, // pgm media.languages options, to set audio/subtitle tracks
        provider: null,
        // TODO checar con android si realmente necesitan pgm
        playerMedia: pgm,
        isPip: nextOptions.ispip,
        parentWrapper: this.wrapperContainer,
        streamContentType: nextOptions.streamContentType
          ? nextOptions.streamContentType
          : null,
        isStartOver:
          nextOptions.isStartOver && nextOptions.isStartOver === true ? true : false,
        isTPA: nextOptions.isTPA ? nextOptions.isTPA : null,
        isFallback: nextOptions.isFallback
      };
    }
  }

  __getAudioParams(nextOptions) {
    return {
      src: nextOptions.islive
        ? Utils.appendParamToUrl(nextOptions.source.audiosource, 'isLiveAudio', true)
        : nextOptions.source.audiosource,
      duration: nextOptions.duration,
      details: nextOptions.details, // TODO ver si el player necesita details, creo que no ¿?
      isPip: nextOptions.ispip,
      isLive: nextOptions.islive,
      streamType: nextOptions.islive ? constant.RADIO : constant.AUDIO,
      parentWrapper: this.wrapperContainer,
      streamContentType: nextOptions.streamContentType
    };
    /**
     isPip(pin): false
     isEnding(pin): false
     src(pin): "http://cdn.imusica.com.br/api/musicStreaming/playTrackCdn?phonogramId=27298628&token_wap=f64H6yvrY0ua1wD5Pt26jgiVpqmXsrTqmXMZp4kcr0&isPreview=0&typeId=6&appId=f14eadf1e22495ac2b404ee4e256a4e2&appVersion=00022b851d34aacd2f00ea5301d26c60&playlistId=47152686"
     controls(pin): true
     muted(pin): false
     autoPlay(pin): true
     isActiveEpg(pin): false
     streamType(pin): "audio"
     backgroundImage(pin): null
     duration(pin): 232
     size(pin): null
     newSource(pin): null


     const nextSong = {
        src            : song.url,
        controls       : true,
        muted          : false,
        autoPlay       : true,
        streamType     : contentType.AUDIO,
        backgroundImage: null,
        duration       : song.durationInSeconds,
        audioSrc       : null,
        imageSrc       : null,
        details : {
            type:         typeDetails(song.songSourceType),
            playlistName: song.playlistName,
            songName:     song.name,
            songNumber:   song.trackNumber,
            albumName:    song.albumName,
            artistName:   song.artist,
        }
        };
     */
  }

  async __awaitGetMedia(nextOptions, isSourceReplace, stype, npvrStreamType) {
    logger.debug('[TSTOP] AAFPlayer main - __awaitGetMedia entrando...');
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __setNextPlayerState'} ${nextOptions && nextOptions.streamContentType ? 'Content_type: ' + nextOptions.streamContentType :''} ${nextOptions && nextOptions.source && nextOptions.source.videoid ? 'Gid: '+ nextOptions.source.videoid :'' }`);

    const lastTimeSendStop = stopTrackingObserver.getLastTimeSendingStop();
    const isSendingStop = stopTrackingObserver.getSendingStop();
    // Si hay una marca de tiempo, es reciente?
    if (lastTimeSendStop && isSendingStop) {
      // Verificar por 5 segundos? si es menor a 5 segundos se espera por el tracking
      const _now = Utils.nowAsTimestampSeconds();
      if ((_now - lastTimeSendStop) <= 5) {
        // Lo que pase primero, el wait o el fire del observer
        if (this.awaitGetMediaIntervalID) {
          clearInterval(this.awaitGetMediaIntervalID);
          this.awaitGetMediaIntervalID = null;
        }
        let ct = 0;
        // Se suscribe al listener
        stopTrackingObserver.unsubscribe(this.__handleAwaitGetMediaObserver);
        stopTrackingObserver.subscribe(this.__handleAwaitGetMediaObserver);
        stopTrackingObserver.setParams({ nextOptions, isSourceReplace, stype, npvrStreamType });

        this.awaitGetMediaIntervalID = setInterval(() => {
          ct += this.awaitGetMediaInterval;
          logger.debug('[TSTOP] AAFPlayer main - __awaitGetMedia en interval, ct: ', ct);
          if (ct >= this.awaitGetMediaIntervalMaxAttemps) {
            logger.debug('[TSTOP] AAFPlayer main - __awaitGetMedia en interval, Va a romper el ciclo');
            // Se rompe el interval y se manda a reproducir, pasa por aquí cuando
            // no llega la notificación del stop
            clearInterval(this.awaitGetMediaIntervalID);
            this.awaitGetMediaIntervalID = null;
            // Reset
            stopTrackingObserver.unsubscribe(this.__handleAwaitGetMediaObserver);
            stopTrackingObserver.setParams(null);
            stopTrackingObserver.setSendingStop(false);

            this.__continuePlaying(nextOptions, isSourceReplace, stype, npvrStreamType);
          }
          // Se espera al siguiente interval
        }, (this.awaitGetMediaInterval * 1000));
      }
      else {
        //Si ya pasó más de 5 segundos ya se desecha el sync
        stopTrackingObserver.setSendingStop(false);
        this.__continuePlaying(nextOptions, isSourceReplace, stype, npvrStreamType);
      }
    }
    else {
      stopTrackingObserver.setSendingStop(false);
      this.__continuePlaying(nextOptions, isSourceReplace, stype, npvrStreamType);
    }
  }

  __continuePlaying(nextOptions, isSourceReplace, stype, npvrStreamType) {
    logger.debug('[TSTOP] AAFPlayer main - __continuePlaying entrando...');

    if (stype === 'vod') {
      this.__continueLoadVOD(nextOptions, isSourceReplace);
    }
    else if (stype === 'live') {
      this.__continueLoadTV(nextOptions, isSourceReplace);
    }
    else if (stype === 'catchup') {
      this.__continueLoadCatchup(nextOptions, isSourceReplace);
    }
    else if (stype === 'timeshift') {
      this.__continueLoadTimeshift(nextOptions, isSourceReplace);
    }
    else if (stype === 'npvr') {
      this.__continueLoadNPVR(nextOptions, isSourceReplace, npvrStreamType);
    }
  }

  // Para VIDEO
  // TV: pgm = await this.__getDataPlaying(nextOptions.source.videoid, false, nextOptions.islive);
  async __getDataPlaying(nextOptions, groupId, isTrailer, isLive, isSourceReplace) {
    let device_config = Device.getDevice().getConfig();
    let supportedStreams = [];
    //let supportedMultipleAudio = device_config.multipleaudio; //Esta llamada al config ya no se usara mas, por que se refactorizó en APA
    let contentType = null;
    let pgm = null;
    let nextContentType = PlayerHelper.getContentType(nextOptions);
    this.log('Next video content type resolved: ', nextContentType);
    /**
     * Por el momento Utils.getApaSupportedStream sólo intenta modificar los streams
     * de *live* si es que epg/channel trae streams disponibles, de otra forma sigue el mismo
     * path que le indica apa
     *
     * Para todos los demás tipos de contenido lo de arriba no aplica (vod, timeshift, catchup/start over)
     */
    let supported_stream_types = nextOptions.supported_stream_types
      ? nextOptions.supported_stream_types
      : Utils.getApaSupportedStream(
        this.platform,
        constant.AAF_CONTENT_IS_TV === nextContentType,
        groupId,
        nextOptions.islive,
      );

    switch (nextContentType) {
      case constant.AAF_CONTENT_IS_VOD:
        //supportedStreams = device_config.supported_stream_types['vod'];// ie. [SS, HLS];
        supportedStreams = supported_stream_types['vod'];
        break;
      case constant.AAF_CONTENT_IS_TV:
        //supportedStreams = device_config.supported_stream_types['live'];// ie [SS];
        supportedStreams = supported_stream_types['live'];
        break;
      case constant.AAF_CONTENT_IS_TIMESHIFT:
        supportedStreams = supported_stream_types['timeshift'];
        break;
      case constant.AAF_CONTENT_IS_STARTOVER:
        supportedStreams = supported_stream_types['timeshift'];
        break;
      case constant.AAF_CONTENT_IS_CATCHUP:
        if (nextOptions && nextOptions.isStartOver === true) {
          supportedStreams = supported_stream_types['timeshift'];
        } else {
          if (Utils.isNotNullOrNotUndefined(supported_stream_types['catchup'])) {
            supportedStreams = supported_stream_types['catchup'];
          } else {
            supportedStreams = supported_stream_types['vod'];
          }
        }
        break;
      default:
        this.__onErrorResolve(
          onResolvePlayingError,
          'Error al intentar reproducir video, falló la resolución del contentType a reproducir',
          nextOptions
        );
        break;
    }

    if (supportedStreams.length > 0) {
      let i = 0;
      let contentId = null;
      let streamType = null;
      let availableStreams = null;
      let desiredLang = null;
      const defaultLang = DeviceStorage.getItem('default_lang');
      let multiple = PlayerHelper.getVideoMultiples(supportedStreams);
      // Force
      // Si ya traigo languageoptions entonces podría saber qué streamType solicitar y si lleva o no un
      // content_id
      if (nextOptions.languageoptions && Utils.isArray(nextOptions.languageoptions)) {
        desiredLang = nextOptions.languageoptions.find(
          language => language.option_id == defaultLang
        );
        if (desiredLang) {
          contentId = desiredLang.content_id;
          availableStreams = desiredLang.encodes;
          let nextStreamTypeIsMultiple = PlayerAudioSubtitleHelper.ifMultipleStreamExists(
            nextContentType,
            availableStreams
          );
          // Tal vez se reemplaza de un múltiple a un single, o de un single a un single
          // Y si es así aquí se resuelve pgm
          if (!nextStreamTypeIsMultiple) {
            // Aquí hay certeza de que existe pgm, o debería de existir pgm
            let sType = PlayerAudioSubtitleHelper.ifSingleStreamExists(
              nextContentType,
              availableStreams
            );
            pgm = await this.__getPGM(
              nextOptions,
              groupId,
              contentId,
              isTrailer,
              sType
            );
            pgm.media.streamType = sType;
            pgm.media.content_id = contentId;
          }
          // else {} Tal vez se reemplaza de un single a un múltiple y si es así, no se hace nada aquí
          // Se resuelve abajo
        }
      }

      // Se resuelven múltiples primero
      if (pgm === null) {
        // Primero revisar por los multiples
        for (i = 0; i < multiple.length; i++) {
          pgm = await this.__getPGM(nextOptions, groupId, null, isTrailer, multiple[i]);
          if (pgm) {
            // Revisar si no viene con error
            if (
              pgm.status &&
              (parseInt(pgm.status) === 400 || parseInt(pgm.status) === 500)
            ) {
              // Es error de streamType ? checa siguiente streamType soportado...
              if (PlayerHelper.isPGMErrorStreamType(pgm)) {
                pgm = null; //Reset pgm para buscar single si es que se neesita hacerlo
                continue; // test siguiente stream type
              }
            } else {
              nextOptions.languageoptions =
                pgm && pgm.group &&
                pgm.group.common && pgm.group.common.extendedcommon &&
                pgm.group.common.extendedcommon.media && pgm.group.common.extendedcommon.media.language &&
                pgm.group.common.extendedcommon.media.language && pgm.group.common.extendedcommon.media.language.options &&
                pgm.group.common.extendedcommon.media.language && pgm.group.common.extendedcommon.media.language.options.option;
              streamType = multiple[i];
              pgm.media.streamType = streamType;
              break;
            }
          }
        }
      }

      // Si nada en multiple, entonces single?, y si es VOD, se busca el content id
      if (pgm === null) {
        if (!isLive) {
          let languageOptions = [];
          if (Utils.isArray(nextOptions.languageoptions)) {
            languageOptions = nextOptions.languageoptions;
          } else {
            let contentData = await Api.getContentData(groupId);
            languageOptions =
              contentData.group &&
              contentData.group.common &&
              contentData.group.common.extendedcommon &&
              contentData.group.common.extendedcommon.media &&
              contentData.group.common.extendedcommon.media.language &&
              contentData.group.common.extendedcommon.media.language.options &&
              contentData.group.common.extendedcommon.media.language.options.option;
          }
          let lang = languageOptions.find(language => language.option_id == defaultLang);
          contentId = lang ? lang.content_id : null;
        }

        supportedStreams = supportedStreams.filter(
          stream => !stream.includes(settings.prepend_multiple)
        );
        for (i = 0; i < supportedStreams.length; i++) {

          // Si es fallback se ignora cualquier error y se continúa con el siguiente stream type
          if(nextOptions.isFallback) {
            try{
              pgm = await this.__getPGM(
                nextOptions,
                groupId,
                contentId,
                isTrailer,
                supportedStreams[i]
              );
              if(pgm && pgm.media && !pgm.media.streamType) {
                pgm.media.streamType = supportedStreams[i];
              }

            } catch(error) {
              if(nextOptions.deleteLastStream) {
                nextOptions.deleteLastStream.push(supportedStreams[i]);
              } else {
                nextOptions.deleteLastStream = [supportedStreams[i]];
              }
              pgm = null;
            }


            if(!pgm || pgm.errors) {
              if(i === supportedStreams.length - 1) {
                const fallbackNextOptions = {...nextOptions};
                fallbackNextOptions.startPlayFalled = true;

                delete fallbackNextOptions.deleteLastStream;
                delete fallbackNextOptions.supported_stream_types;

                this.__onErrorResolve(
                  onResolvePlayingError,
                  'api_error',
                  fallbackNextOptions
                );
                break
              }
              continue
            }
            return pgm;
          }

          pgm = await this.__getPGM(
            nextOptions,
            groupId,
            contentId,
            isTrailer,
            supportedStreams[i]
          );
          if (pgm) {
            // Para pruebas max devices --> pgm = {"entry":{"group_id":"791255","stream_type":"smooth_streaming","preview":"0","HKS":"lt29dfdqar3uj54glnsglagr23","api_version":"v5.88","authpn":"amco","authpt":"12e4i8l6a581a","device_category":"tv","device_manufacturer":"lg","device_model":"web0s","device_type":"TV","device_id":"88dc5f85-0c2d-4884-e3c5-9bf6548b8d6f","device_name":"lg","device_so":"webos","region":"colombia","format":"json","user_id":"33144486","user_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1Njc3MDY0MTgsImV4cCI6MTU3Mjg5MDQxOCwidXNyIjp7InVzZXJfaWQiOiIzMzE0NDQ4NiIsInVzZXJfdHlwZSI6IkNDT05PVklQIiwidXNlcm5hbWUiOiJjb2xvbWJpYS5qY2M4N0BnbWFpbC5jb20iLCJlbWFpbCI6ImNvbG9tYmlhLmpjYzg3QGdtYWlsLmNvbSIsImZpcnN0bmFtZSI6InRlc3QiLCJsYXN0bmFtZSI6InRlc3QiLCJjb3VudHJ5X2NvZGUiOiJDTyIsInJlZ2lvbiI6ImNvbG9tYmlhIiwiYWNjZXB0ZWRfdGVybXMiOjEsImdhbWlmaWNhdGlvbl9pZCI6IjVjMDUwM2VkMTg1MTFjNmFiNDI5MDlmZCIsInBhcmVudF9pZCI6IjMzMTQ0NDg2IiwiYWNjb3VudCI6IjEwNjYzMjc2IiwiYWRtaW4iOnRydWV9fQ.KNFJuMGtWg4bfh40jQxFMqTSdHETKag9vASVfVnQHT0","payway_token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1Njc3MDU4NjAsImV4cCI6MTU2Nzc5MjI2MCwicGdzIjp7InVzZXJfaWQiOiIzMzE0NDQ4NiIsInBfdXNlcl9pZCI6IjMzMTQ0NDg2Iiwib2ZmZXJpZCI6IjE0MzI3OTkyIiwicHVyY2hhc2VpZCI6IjQzMTA3NDk5NyIsImdyb3VwIjoiNzkxMjU1IiwicGxheSI6MSwiY19kaXNwX3AiOiI1In19.Ab-jJS1l-LAgPnN810rwkKAh_uGFmwF62P4Iblm2grw"},"status":400,"errors":[{"message":"You have reached the maximum number of devices in your account","code":"PLY_DEV_00006","exception":"L2luZXRwdWIvc2VydmljZXMvc3JjL0FtY28vRGV2aWNlLnBocCA0OTA="}]};

            // Revisar si no viene con error
            if (
              (pgm.status && parseInt(pgm.status) === 400) ||
              (pgm.status && parseInt(pgm.status) === 402) ||
              parseInt(pgm.status) === 500
            ) {
              // Es error de streamType ? checa siguiente streamType soportado
              if (PlayerHelper.isPGMErrorStreamType(pgm)) {
                continue; // test siguiente stream type
              } else {
                // Si es otro tipo de error, break y manda error a pantalla, ya no hace más llamadas a getmedia
                break;
              }
            } else {
              streamType = supportedStreams[i];
              // Pegarle el content_id a pgm (para poder playear, nagra por ej.)
              if (contentId === null) {
                // Si no hay preferencia, se busca por el default
                if (pgm.language && pgm.language.options) {
                  contentId = pgm.language.options.find(lang => lang.is_current)
                    .content_id;
                  // set storage(init storage)
                  let optionId = pgm.language.options.find(
                    lang => lang.is_current
                  ).option_id;
                  // Set preference in storage, to build and show combo languages properly
                  DeviceStorage.setItem('default_lang', optionId);
                }
              }
              // En recording se va a ir null el content_id, reproducirá nagra?
              pgm.media.content_id = contentId;
              pgm.media.streamType = streamType;
              break;
            }
          }
        }
      }
      if (pgm === null) {
        this.__onErrorResolve(
          onResolvePlayingError,
          'Error, el contenido no se puede reproducir en este dispositivo',
          nextOptions
        );
      }
    } else {
      nextOptions.startPlayFalled = true;
      this.__onErrorResolve(
        onResolvePlayingError,
        Translator.get('noSupportedStreaming_modal_description_label','El device no tiene definidos los tipos de streaming que soporta'),
        nextOptions
      );
    }

    const videoURL = (pgm.media && pgm.media.video_url);
    if (videoURL) {
      let url = videoURL;
      const unsupportedDevice = Utils.isSamsungOrsay() || Utils.isPlaystation4() || Utils.isTizenLegacy();
      if (unsupportedDevice) {
        const videoURLencode= encodeURIComponent(videoURL);
        url = `${getAppConfig().end_point_middleware}checkUrl?url=${videoURLencode}`;
      }
      const responseURL = await this.checkVideoURL(url, unsupportedDevice);
      if (responseURL) pgm.media.video_url = responseURL;
    }
    return pgm;
  }

  async checkVideoURL(videoURL, unsupportedDevice) {
    let responseURL = null;
    try {
      if (unsupportedDevice) {
        const task = new CheckUrlTask(videoURL);
        const response = await new RequestManager.addRequest(task);
        responseURL = (response && response.data && response.data.url) || null;
      } else {
        const requestMethod = "GET";
        const response = await this.simpleXMLHttpRequest(requestMethod, videoURL);
        responseURL = (response && response.responseURL) || null;
      }
      return responseURL;
    } catch (error) {
      logger.debug("Error trying to get checkVideoURL", error);
    }
  }

  simpleXMLHttpRequest(method = "GET", url = null) {
    if (url) {
      const xhrRequest = new XMLHttpRequest();
      xhrRequest.open(method, url);
      return new Promise((resolve, reject) => {
        xhrRequest.onerror = (error) => reject(error);
        xhrRequest.onreadystatechange = () => {
          if (xhrRequest.readyState === 4) {
            resolve(xhrRequest)
          }
        }
        xhrRequest.send();
      })
    }
  }

  async __getCurrentLanguage(languageOptions, streamType) {
    //Regresa el idioma seteado con la propiedad is_current de el arreglo languageOptions
    const existeLang = languageOptions.find(language => language.is_current === true);
    if (existeLang && existeLang.encodes && existeLang.encodes.some(x => x == streamType)) {
      return streamType;
    }
    return null;
  }

  async __getPGM(nextOptions, groupId, content_id, isTrailer, streamType) {
    logger.debug('__getPGM ', nextOptions);
    let startTime = Utils.isNullOrUndefined(nextOptions.starttime)
      ? null
      : nextOptions.starttime;
    let endTime = Utils.isNullOrUndefined(nextOptions.endtime) ? null : nextOptions.endtime;
    let payway_token = Utils.isNullOrUndefined(nextOptions.payway_token)
      ? null
      : nextOptions.payway_token;

    if (startTime || endTime) {
      isTrailer = false;
    }

    const isFallback = PlayerHelper.isFallback(null, nextOptions);
    const isTs = nextOptions && nextOptions.streamContentType && (nextOptions.streamContentType === constant.AAF_CONTENT_IS_CATCHUP || nextOptions.streamContentType === constant.AAF_CONTENT_IS_STARTOVER);
    if (payway_token === null && (nextOptions.islive || isTs)) {
      payway_token = this.playerStreamingUtils.getPaywayToken(groupId, isFallback);
    }
    const { playerContentData: { item_brand = null } = {} } = store.getState();
    if (item_brand) nextOptions.provider = item_brand;

    return await Api.getMedia(
      groupId,
      content_id,
      isTrailer,
      streamType,
      startTime,
      endTime,
      payway_token,
      {...nextOptions}
    );
  }

  // detail es un obj, el response de pgm, hasta ahorita
  __onErrorResolve(typeError, msg, object_detail) {
    this.setTryingToPlayOptions(null);
    let exception = new AAFResolveException(typeError, msg, object_detail);
    logger.error(exception.message, exception);
    NewRelic.actionText(`${'LogType: Newrelic File: AAFPlayerMain.js'} ${'Method: __onErrorResolve'} ${'Exception: ' + exception }`);

    // Lanzar modales (pin parental, handlebookmark, error reintento, network disconnect, pgm errors, replay, etc)
    switch (typeError) {
      case onResolvePlayingError:
        if (
          this.callbacks.onResolveError &&
          Utils.isFunction(this.callbacks.onResolveError)
        ) {
          this.callbacks.onResolveError(exception);
        }
        break;
      // Los errores de abajo se envian en otro callback
      case onResolveGetmediaError:
      case onStreamNotFound:
      case onConnectionTimeout:
      case onNetworkDisconnected:
      case onAuthenticationFailed:
      case onUnknownError:
      default:
        break;
    }
    // To console log
    throw exception;
  }

  /**
   * Calcular fin player
   */
  getRollingCreditsTime() {
    if (this.devicePlayerParams.isLive || this.devicePlayerParams.isTrailer) return null;

    // if audio (stream or live ) or image...nothing to do
    if (
      this.devicePlayerParams.streamType === playerConstant.AUDIO ||
      this.devicePlayerParams.streamType === playerConstant.RADIO ||
      this.devicePlayerParams.streamType === playerConstant.PLAYERIMAGE
    ) {
      return null;
    }
    let creditsTime = this.devicePlayerParams.creditsTime;
    logger.debug(
      '[AAFPlayer] creditsTime from api: ' +
      this.devicePlayerParams.creditsTime +
      ', duration: ' +
      this.getDuration()
    );
    if (!creditsTime) creditsTime = settings.rolling_credits_time;

    // resume in seconds or minutes?
    creditsTime = this.getEndTimeToSeconds(creditsTime);

    if (creditsTime && creditsTime < 0) {
      creditsTime = creditsTime + this.getDuration();
    }

    return creditsTime;
  }

  getEndTimeToSeconds(ctime) {
    logger.debug('[AAFPlayer] creditsTime @@@@@@@@@@@ from api: ', ctime);
    let creditsTime = ctime.toString();
    if (creditsTime.indexOf(':') !== -1) {
      let ctime2 = creditsTime.split(':');
      ctime = (Number(ctime2[0]) * 60 + Number(ctime2[1])) * 60 + Number(ctime2[2]);
    } else {
      ctime = Number(ctime);
    }

    return ctime;
  }

  isEndScreen(currentTime) {
    /**
     * START
     * Verificar si es start over / catchup
     * AAFMain resuelve un catchup como vod en currentContentType
     * entonces revisar startTime y endTime
     *
     * Hasta este momento, no hay fin player para start over, "no se pidió dentro del alcance", por tanto tampoco hay recomendados
     */
    let currOptions = this.getCurrentPlayerOptions();
    let isStartOver =
      Utils.isNotNullOrNotUndefined(currOptions.starttime) &&
      Utils.isNotNullOrNotUndefined(currOptions.endtime);
    /**
     * END
     */

    const { isTrailer, isLive, isPip, currentContentType } = this.devicePlayerParams || {};

    if (
      isTrailer ||
      isLive ||
      isPip ||
      this.playerInstance.streamIsImage() ||
      currentContentType === constant.AAF_CONTENT_IS_NPVR ||
      isStartOver
    ) {
      this.isEndPlayer = false;
      this.creditsTime = null;
    } else {
      if (this.creditsTime === null) {
        this.isEndPlayer = false;
        return;
      } else {
        if (this.creditsTime > 0 && currentTime >= this.creditsTime) {
          if (!this.isEndPlayer) {
            if (
              this.callbacks.onPlayerEndPlayer &&
              Utils.isFunction(this.callbacks.onPlayerEndPlayer)
            ) {
              this.callbacks.onPlayerEndPlayer(this.getDevicePlayerParams(false));
            }

            this.isEndPlayer = true;
            logger.debug('[AAFPlayer] dispatch/fire event finplayer');
            this.setPlayerBackground(null);

            // Ahora el nuevo fin player es una modal,
            // Se lanza la modal
            if (
              this.callbacks.onResolveShowModal &&
              Utils.isFunction(this.callbacks.onResolveShowModal)
            ) {
              let modalData = {
                modalType: MODAL_END_PLAYER,
                pgm: this.pgm
              };
              this.callbacks.onResolveShowModal(modalData);
            }
            document.dispatchEvent(
              new CustomEvent(settings.end_vod_fire_event, {
                detail: this.getDevicePlayerParams(false)
              })
            );
          }
        }
        else {
          this.isEndPlayer = false;
        }
      }
    }
  }

  /**
   * Tools background y playerState
   * TODO se va sobre el full, no pip
   */
  setPlayerBackground(src) {
    this.playerInstance.setPlayerBackground(src);
  }

  getCurrentPlayerState(ispip) {
    return ispip
      ? this.playerInstancePip.getCurrentPlayerState()
      : this.playerInstance.getCurrentPlayerState();
  }

  // TODO si pip no se usa ahorita, se va sobre el full que sí le interesa trackear eventos
  setCurrentPlayerState(state, ispip) {
    return this.playerInstance.setCurrentPlayerState(state);
  }

  /**
   * Extra tools
   */
  // TODO si pip no se usa ahorita
  getCurrentTime() {
    if (this.playerInstance) {
      return this.playerInstance.getCurrentTime();
    }
    return 0;
  }

  // TODO si pip no se usa ahorita
  getDuration() {
    return this.playerInstance.getDuration();
  }

  // TODO si pip no se usa ahorita
  show() {
    this.playerInstance.show();
  }

  // TODO si pip no se usa ahorita
  hide() {
    this.playerInstance.hide();
  }
}

export default AAFPlayerMain;



// WEBPACK FOOTER //
// ./src/AAFPlayer/common/AAFPlayerMain.js